// 1.0 DEFINE CONST
const _document = $(document);
const _window = $(window);
const windowWidth = _window.width();
const windowHeight = _window.height();
const html = $('html');
const body = $('body');

const screenisCompact = 1200 >= windowWidth
	? true : false;
const screenIsTablet = 900 >= windowWidth
	? true : false;
const screenIsMobile = 600 >= windowWidth
	? true : false;
const scrollOffset = 95 - 1;


// PINCH ZOOM
const pinchZoom = (imageElement) => {
    let imageElementScale = 1;

    let start = {};

    // Calculate distance between two fingers
    const distance = (event) => {
        return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    };

    imageElement.addEventListener('touchstart', (event) => {
        // console.log('touchstart', event);
        if (event.touches.length === 2) {
            event.preventDefault(); // Prevent page scroll

            // Calculate where the fingers have started on the X and Y axis
            start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
            start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
            start.distance = distance(event);
        }
    });

    imageElement.addEventListener('touchmove', (event) => {
        // console.log('touchmove', event);
        if (event.touches.length === 2) {
            event.preventDefault(); // Prevent page scroll

            // Safari provides event.scale as two fingers move on the screen
            // For other browsers just calculate the scale manually
            let scale;
            if (event.scale) {
                scale = event.scale;
            } else {
                const deltaDistance = distance(event);
                scale = deltaDistance / start.distance;
            }
            imageElementScale = Math.min(Math.max(1, scale), 4);

            // Calculate how much the fingers have moved on the X and Y axis
            const deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2; // x2 for accelarated movement
            const deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2; // x2 for accelarated movement

            // Transform the image to make it grow and move with fingers
            const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
            imageElement.style.transform = transform;
            imageElement.style.WebkitTransform = transform;
            imageElement.style.zIndex = "9999";
        }
    });

    imageElement.addEventListener('touchend', (event) => {
        // console.log('touchend', event);
        // Reset image to it's original format
        imageElement.style.transform = "";
        imageElement.style.WebkitTransform = "";
        imageElement.style.zIndex = "";
    });
}

// 2.0 TOOLS/UTILITIES

const scrollTo = (id) => {
	let scrollContainer = html;
	let scrollPosition = typeof id != 'number'
		? id == 'window'
			? windowHeight
			: $(id).length
				? $(id).offset().top
				: 0
		: windowHeight * (id / 100);

	if (getComputedStyle(scrollContainer[0]).scrollBehavior === 'smooth') {
		scrollContainer.scrollTop(scrollPosition - scrollOffset);
	} else {
		scrollContainer.animate({
			scrollTop: scrollPosition - scrollOffset
		});
	}
}

const formatHandleize = (string) => {
	return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
}

const formatLeadingZero = (value) => {
	return (value < 10 ? '0' : '') + value;
}

const formatCommify = (value) => {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const validateEmail = (email) => {
	let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test(email);
}

$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	}
});

const siteReadyTrigger = (punk, delay) => {
	document.addEventListener('readystatechange', event => {
		if (document.readyState == 'complete') {
			(delay) ? setTimeout(punk, delay) : punk();
		}
	});
}

const loadingBarTrigger = (stage) => {
	const loadingBar = $('#loading-bar');

	let action = (loadingBar.css('opacity') == 1 && stage != 'done')
		? 'move' : stage

	switch (action) {
		case 'start':
			loadingBar.css('opacity', 1)
				.width(windowWidth * (Math.floor(Math.random() * 6) + 1) / 10);
			break;

		case 'move':
			loadingBar.css('opacity', 1)
				.width(loadingBar.width() * 1.15);
			break;

		case 'done':
			loadingBar.width(windowWidth);

			setTimeout(function () {
				loadingBar.css('opacity', 0);
			}, 300);

			setTimeout(function () {
				loadingBar.width(0);
			}, 600);
			break;
	}
}

// 3.0 PAGES/COMPONENTS

const initPageTransition = () => {
	let siteUrl = shopUrl.replace('www.', '').replace('http://', '').replace('https://', '');

	$('a[href]').each(function () {
		let _this = $(this);
		let href = _this.attr('href');

		if ((href.includes(siteUrl) || href.startsWith('/') || href.startsWith('#')) &&
			_this.attr('target') != '_blank' && !href.includes('mailto:')) {
			_this.attr('data-location', 'internal');

		} else {
			_this.attr('data-location', 'external')
		}
	});

	_document.on('click', 'a[href]', function (e) {
		let _this = $(this);
		let href = _this.attr('href');
		let hrefSplitHash = href.split('#');
		let windowHrefSplitHash = window.location.href.split('#');

		html.removeClass('mobile_menu_active minicart_active search_pane_active');

		// if hash origin url is current url
		if (href.startsWith('#') ||
			hrefSplitHash[0] == windowHrefSplitHash[0]) {
			e.preventDefault();

			// scroll to hash location
			scrollTo(`#${hrefSplitHash[1]}`);

		} else if (_this.attr('data-location') == 'internal' &&
			keyOnPress == false) {
			e.preventDefault();

			html.addClass('is_leaving');

			window.location.href = href;
		}
	});
}


const initPageAnimation = () => {
	const animationScroll = () => {
		const scrollTopOffsetAni = scrollTop + windowHeight * 0.85

		// get all anchor with top offset
		$('[data-ani-anchor]:not([data-ani-anchor="onload"])').each(function () {
			let _this = $(this);
			let _thisTop = parseInt(_this.attr('data-ani-top'));

			if (scrollTopOffsetAni > _thisTop &&
				!_this.hasClass('animate')) {
				_this.addClass('animate')

				_this.trigger('animate');
			}
		});
	}

	siteReadyTrigger(function () {
		$('[data-ani-anchor]').each(function () {
			let _this = $(this);

			// if animates on load, trigger animate immediately
			(_this.data('ani-anchor') == 'onload')
				? _this.addClass('animate') : '';

			_this.attr('data-ani-top',
				Math.floor(_this.offset().top));
		});

		animationScroll();
		_window.scroll(animationScroll);
	}, 50);
}

const initHeader = () => {
	const header = $('#header');
	const headerBg = header.find('#header-bg');
	const headerFill = html.hasClass('header_fill')
		? true : false;
	const logoSvg = header.find('.svg-logo');
	const linksLi = header.find('.header-links > li');

	let logoSvgCssHeight = logoSvg.css('height').replace('px', '');
	let linksLiCssLineHeight = linksLi.css('line-height').replace('px', '');

	const headerScroll = () => {
		(scrollTop > 10 || headerFill == true)
			? html.addClass('header_fill')
			: (!html.hasClass('search_pane_active') &&
				!html.hasClass('mobile_menu_active'))
				? html.removeClass('header_fill')
				: '';

		if (!screenisCompact) {
			linksLi.css('line-height', `${(scrollTop > 0
				? (linksLiCssLineHeight - scrollTop / 4 >= 60)
					? linksLiCssLineHeight - scrollTop / 4
					: 60
				: linksLiCssLineHeight)}px`);

			logoSvg.css('height', `${(scrollTop > 0
				? (logoSvgCssHeight - scrollTop / 4 >= 40)
					? logoSvgCssHeight - scrollTop / 4
					: 40
				: logoSvgCssHeight)}px`);
		}
	}
	siteReadyTrigger(headerScroll);
	_window.on('scroll', headerScroll);

	if (headerFill == false) {
		header.on('mouseenter mousemove', function () {
			html.addClass('header_fill');
		}).mouseleave(function () {
			if (!html.hasClass('search_pane_active') &&
				!html.hasClass('mobile_menu_active')) {
				(scrollTop == 0 &&
					!html.hasClass('mobile_menu_active'))
					? html.removeClass('header_fill')
					: html.addClass('header_fill');
			}
		});
	}

	// header menu
	const menuClose = () => {
		menuCloseTrigger = setTimeout(function () {
			$(`[data-header-menu-trigger], 
				[data-header-menu]`).removeClass('active');
		}, 0);
	}
	menuOpenTrigger = menuCloseTrigger = null;

	$('[data-header-menu-trigger]').mouseenter(function () {
		let _this = $(this);
		menuOpenTrigger = setTimeout(function () {
			_this.addClass('active')
				.siblings().removeClass('active');
				hj('trigger', 'mega_menu');
			$(`.header-menu[data-header-menu="${_this.attr('data-header-menu-trigger')}"]`).addClass('active')
				.siblings('.header-menu').removeClass('active');
		}, 150);

		clearTimeout(menuCloseTrigger);
	}).mouseleave(function () {
		clearTimeout(menuOpenTrigger);
		menuClose();
	});

	$('.header-menu').mouseenter(function () {
		clearTimeout(menuCloseTrigger);
	}).mouseleave(menuClose);

	// responsive mobile menu
	const mobileMenuTrigger = $('#mobile-menu-trigger');
	const mobileMenuOverlay = $('#mobile-menu-overlay');

		mobileMenuTrigger.click(function () {
			console.log("DALEE1")
			html.toggleClass('mobile_menu_active');

			if (headerFill == false && scrollTop <= 10) {
				(html.hasClass('mobile_menu_active'))
					? html.addClass('header_fill')
					: html.removeClass('header_fill');
			}
		});

		mobileMenuOverlay.click(function () {
			html.removeClass('mobile_menu_active');

			(headerFill == false && scrollTop <= 10)
				? html.removeClass('header_fill')
				: html.addClass('header_fill');
		});

		// move header-menus to mobile menu
		$('[data-header-menu]').clone()
			.prependTo('#mobile-menu-content');

		// open header-menus
		$('[data-mobile-menu-trigger]').click(function () {
			$(`.header-menu[data-header-menu="${$(this).attr('data-mobile-menu-trigger')}"]`).addClass('active')
				.siblings('.header-menu').removeClass('active');
		});

		// close header-menus
		$('.header-menu-close').click(function () {
			$(this).closest('.header-menu').removeClass('active');
		});

		_window.click(function (e) {
			let target = $(e.target);

			if (html.hasClass('mobile_menu_active') &&
				!target.is('#mobile-menu') &&
				!target.closest('#mobile-menu').length &&
				!target.is('#mobile-menu-trigger') &&
				!target.closest('#mobile-menu-trigger').length) {

				html.removeClass('mobile_menu_active');
			}
		});
}

const initNewsletterPopup = () => {
	const newsletter = $('#newsletter-popup');
	const newsletterClose = newsletter.find('#newsletter-popup-close');
	const newsletterId = 'viewSourceCreative' + '0111-3-2021';
	const timeNow = new Date().getTime();
	const timeSetup = localStorage.getItem('luNewsletterTimeSetup');

	// exit if no newsletter nor does browser have local storage capability
	if (!newsletter.length && hasLocalStorage !== true) {
		return false;
	}

	// if timer is not setup
	if (timeSetup === null) {
		localStorage.setItem('luNewsletterTimeSetup', timeNow);

		// if timer is setup, but passes expiration
	} else if (timeNow - timeSetup > 3 * 24 * 60 * 60 * 1000) {
		// reset timer
		localStorage.removeItem(newsletterId);
		localStorage.setItem('luNewsletterTimeSetup', timeNow);
	}

	// reveal newsletter popup after 3 seconds, if user has scrolled pass half window height
	newsletterActiveTrigger = setInterval(function () {
		if (window.location.pathname != '/challenge' &&
			localStorage.getItem(newsletterId) !== 'closed' &&
			scrollTop > windowHeight / 2) {
			html.addClass('newsletter_popup_active');
			clearInterval(newsletterActiveTrigger);
		}
	}, 3000);

	const newsletterCloseTrigger = () => {
		localStorage.setItem(newsletterId, 'closed');
		html.removeClass('newsletter_popup_active');

		setTimeout(function () {
			newsletter.remove();
		}, 600);
	}

	// close newsletter on click
	newsletterClose.click(newsletterCloseTrigger);
}

const initSearchPane = () => {
	const searchPaneTrigger = $('.header-search-pane-trigger');
	const searchPane = $('#header-search-pane');

	const searchForm = $('#header-search-form');
	const searchInput = searchForm.find('input[type="text"]');
	const searchClear = searchForm.find('#header-search-clear');
	const searchResults = $('#header-search-results');
	const searchUrl = 'https://www.lunya.co/search';

	searchViewAllButton =
		productSearchRequest =
		articleSearchRequest =
		searchInputThrottle = null;

	const searchReset = () => {
		searchInput.val('');
		searchResults.empty();
		html.removeClass('search_pane_has_value');

		loadingBarTrigger('done');
	}

	const searchResultsTrigger = () => {
		clearTimeout(searchInputThrottle);

		searchInputThrottle = setTimeout(function () {
			let term = searchInput.val();

			if (term.length >= 3 &&
				term != searchInput.attr('data-term')) {
				// add active state
				html.addClass('search_pane_has_value');

				// register search term to avoid double triggering ajax
				searchInput.attr('data-term', term);

				// start loading state
				loadingBarTrigger('start');

				// if abort current ajax request, if exists
				(productSearchRequest !== null)
					? productSearchRequest.abort() : '';

				(articleSearchRequest !== null)
					? articleSearchRequest.abort() : '';

				// trigger ajax request
				productSearchRequest = $.getJSON(
					`${searchUrl}?type=product&q=${term}&view=json`
				).always(function (data) {
					searchProductResults = '';

					if (data.results_count > 0) {
						searchViewAllButton = (data.results_count > 2)
							? true : false;

						searchProductResults += `<div id="search-product-list">
							<div class="t-link cr-subdued">Products</div>`;

						$.each(data.results, function (i, item) {
							if (i < 2 && item.title.toLowerCase().indexOf("gift box") === -1) {
								searchProductResults += `<div 
										class="search-product g-flex">
										<a href="${item.url}" title="${item.title}"></a>
										<div class="search-product-thumbnail thumbnail">
											${(!item.thumbnail.includes('no-image'))
										? `<span class="object-fit">
													<img 
														src="${item.thumbnail}" 
														alt="${item.title}">
													</span>`
										: ''
									}
										</div>
										<div class="search-product-content">
											<div class="t-b-2">${item.title}</div>
											<div class="t-b-2 cr-subdued">${item.price}</div>
										</div>
									</div>`;
							}
						});
						searchProductResults += `</div>`;
					}
				});

				articleSearchRequest = $.getJSON(
					`${searchUrl}?type=article&q=${term}&view=json`
				).always(function (data) {
					searchArticleResults = '';

					if (data.results_count > 0) {
						searchViewAllButton = (searchViewAllButton == true ||
							data.results_count > 2)
							? true : false;

						searchArticleResults += `<div id="search-article-list" class="t-b-2">
							<div class="t-link cr-subdued">Blog Posts</div>
							<ul class="t-b-2">`;

						$.each(data.results, function (i, item) {
							if (i < 4 && !item.url.includes('/pages/')) {
								searchArticleResults += `<li>
										<a href="${item.url}">${item.title}</a>
									</li>`;
							}
						});

						searchArticleResults += `</ul>
						</div>`;
					}
				});

				$.when(
					productSearchRequest, articleSearchRequest
				).done(function () {
					loadingBarTrigger('done');

					(searchArticleResults == '' &&
						searchProductResults == '')
						? searchResults.addClass('no-results')
						: searchResults.removeClass('no-results')

					searchResults.html(`${(searchArticleResults == '' &&
						searchProductResults == '')
						? `<div id="search-no-results">
								<div class="t-b-2 cr-gray-d">No results for your search term.</div>
							</div>`
						: `${searchProductResults}${searchArticleResults}${(searchViewAllButton == true)
							? `<div id="search-results-view-all">
										<a 
											class="btn-block" 
											href="${`${searchUrl}?q=${term}`}">
											View All Results</a>
										</div>`
							: ''
						}`
						}`);
				});

			} else if (term.length == 0) {
				searchReset();
			}
		}, 450);
	}

	searchPaneTrigger.click(function () {
		html.toggleClass('search_pane_active');

		setTimeout(function () {
			html.hasClass('search_pane_active')
				? searchInput.focus()
				: '';
		}, 300);
	});

	_window.click(function (e) {
		let target = $(e.target);

		if (html.hasClass('search_pane_active') &&
			!target.is('.header-search-pane-trigger') &&
			!target.closest('.header-search-pane-trigger').length &&
			!target.is('#header-search-pane') &&
			!target.closest('#header-search-pane').length) {

			html.removeClass('search_pane_active');
			setTimeout(searchReset, 300);
		}
	});

	searchInput.on('keyup change', searchResultsTrigger);

	searchForm.on('submit', function (e) {
		e.preventDefault();

		window.location.href = `${searchUrl}?q=${searchInput.val()}`;
	}).on('clearSearch', searchReset);

	searchClear.on('click', function (e) {
		e.preventDefault();

		searchReset();
	});
}

const initSearchIndex = () => {
	const searchHeaderInput = $('#search-header-input');
	const searchHeaderClear = $('#search-header-clear');

	searchHeaderInput.on('keyup change', function () {
		(searchHeaderInput.val())
			? html.addClass('search_header_input_has_value')
			: html.removeClass('search_header_input_has_value')
	});

	searchHeaderClear.click(function () {
		searchHeaderInput.val('').focus();
	});

	const searchResultsTabButton = $('#search-results-tab button');

	searchResultsTabButton.click(function () {
		let _this = $(this);

		_this.addClass('active')
			.siblings().removeClass('active');

		_this.parent().attr('data-results-tab',
			_this.attr('data-results-tab-trigger'));
	});
}

const initFrontpage = () => {
	const hero = $('#frontpage-hero');
	ctaCollapseTimer = null;

	const frontpageScroll = () => {
		clearTimeout(ctaCollapseTimer);

		ctaCollapseTimer = setTimeout(function () {
			(scrollTop > windowHeight / 3)
				? hero.addClass('cta_collapse')
				: hero.removeClass('cta_collapse');
		}, 150);
	}

	if (!screenIsTablet) {
		_window.scroll(frontpageScroll);
	}
}

const initCollectionListing = () => {
	$('#collection-listing-featured .slide-content-b a').each(function () {
		let _this = $(this);

		_this.attr('href', `#collection-listing-${formatHandleize(_this.siblings('.t-b-1').text())
			}`);
	});
}

const initProductIndex = () => {
	const collectionProducts = $('#collection-products');
	const toolbarMobile = $('#collection-toolbar-mobile');

	const toolbar = (!screenIsMobile)
		? $('#collection-toolbar')
		: toolbarMobile;
	const toolbarContent = toolbar.find('#collection-toolbar-content');
	const toolbarDropdown = toolbar.find('.toolbar-dropdown');
	const toolbarDropdownTrigger = toolbar.find('[data-dropdown-trigger]');

	const productsInfiniteScroll = () => {
		collectionProducts.infinitescroll({
			errorCallback: function () {
				html.addClass('collection_load_end');

				loadingBarTrigger('done');
			}
		}, function (i) {
			$(i).addClass('css_fadeIn animate')
				.appendTo('.collection-products-grid .comp-grid-3');

			$(i).find('[data-swatch-image].active')
				.click().trigger('mouseenter');

			loadingBarTrigger('done');
		});
	}

	const removeEditorialBlocks = () => {
		$('.collection-products-editorial, .collection-products-editorial-inline-1, .collection-products-editorial-inline-2').remove();

		$('.collection-products-grid .comp-grid-3').children().unwrap();
		$('.collection-products-grid').children().unwrap();

		$('#collection-products').addClass('comp-grid-3 g-flex')
			.wrapAll('<div class="width"></div>');
	}

	const colorFilter = () => {
		$('#collection-products').css('visibility','hidden')
		$('#collection-load-more').css('display','none')
		let activeColor = (toolbar.find(`li.active [data-filter-trigger*="Color:"]`).attr('data-filter-trigger'))
			? toolbar.find(`li.active [data-filter-trigger*="Color:"]`).attr('data-filter-trigger').replace('Color:', '')
			: false;
		let checkArray = JSON.parse(filter_colors) ?? []
		let colorExist, colorSplit
		if (activeColor) {
			colorExist =  checkArray.find(color => color.main_color == activeColor)
			colorSplit = colorExist["subcolors"].toUpperCase().split(',')
		}
		if (colorExist) {
			$('.comp-product-card').each(function () {
				let swatches = $(this).find('[data-swatch-color]');
				let activeSwatch;
				$(swatches).each(function () {
					let colorFound = colorSplit.find(color => color == $(this).attr('data-swatch-color').toUpperCase())
					if (colorFound) {
						activeSwatch = $(this)
					}
				})
				$(activeSwatch).length > 0 ? $(activeSwatch).first().click().trigger('mouseenter') : $(this).remove()
			});
		}

		setTimeout(function () {
			$('#collection-products').css('visibility','visible')
		}, 3000);

	}

	if (screenIsTablet) {
		toolbarMobile.find('#toolbar-mobile-filter-content')
			.prepend($('#collection-toolbar-filter').html());
	}

	colorFilter();

	// product loading
	productsInfiniteScroll();
	_window.unbind('.infscr');
	_document.on('click', '#collection-load-more', function () {
		loadingBarTrigger('start');
		collectionProducts.infinitescroll('retrieve');
		$('#infscr-loading').remove();
	});

	// toggle filter/sort dropdowns
	const toolbarDropdownClose = () => {
		if (toolbar.find('.toolbar-dropdown.active')) {
			html.removeClass('toolbar_active');
			toolbar.find('.toolbar-dropdown.active').removeClass('active')
		}
	}

	toolbarDropdownTrigger.click(function () {
		let dropdownActive = $(this).closest('.toolbar-dropdown');

		if (dropdownActive.hasClass('active')) {
			toolbarDropdownClose();
		} else {
			html.addClass('toolbar_active');
			toolbarDropdown.removeClass('active');
			dropdownActive.addClass('active');
		}
	});

	toolbar.on('mouseleave', toolbarDropdownClose);

	// toolbar and product filtering/sorting
	const toolbarCurrent = $('#collection-toolbar-current');
	collectionProductRequest = null;

	const toolbarRefresh = () => {
		let urlParams = new URLSearchParams(window.location.search);
		let urlParamsSort = urlParams.get('sort_by');

		// determine active state for sort
		if (urlParamsSort && urlParamsSort != 'manual') {
			toolbar.find(`[data-sort-trigger="${urlParamsSort}"]`).closest('li').addClass('active')
				.siblings().removeClass('active');
		}

		// determine active filters
		let filterActiveTerms = [];

		toolbar.find(`li.active [data-filter-trigger]`).each(function () {
			filterActiveTerms.push($(this).attr('data-filter-trigger'));
		});

		// if has terms
		if (filterActiveTerms.length) {
			// create toolbar current HTML
			toolbarCurrent.html(`
				<ul>${filterActiveTerms.map(item =>
				`<li>
						<button data-filter-clear-trigger="${item}">${item.split(':')[1]}</button>
					</li>`
			).join('')}</ul>

				<button data-filter-clear-trigger="all">Clear</button>
			`).show();

			removeEditorialBlocks();
		} else {
			// else, clear toolbar
			toolbarCurrent.empty().hide();
		}
	}

	const productRefresh = () => {
		// trigger fade in for all sections due to the shift in product grid height
		$('[data-ani-anchor]:not(.animate)').addClass('animate');

		// if abort current ajax request, if exists
		(collectionProductRequest !== null)
			? collectionProductRequest.abort() : '';

		// initiate loading bar
		loadingBarTrigger('start');

		// fade out product grid
		collectionProducts.addClass('css_fadeOut')
			.removeClass('css_fadeIn');

		// generate filter URL
		let filterActiveTerms = [];
		let sortActiveTerm = $('li.active [data-sort-trigger]').attr('data-sort-trigger');

		toolbar.find('li.active [data-filter-trigger]').each(function () {
			let tag = $(this).attr('data-filter-trigger')
				.replace(/\s+/g, '-').toLowerCase();

			(!filterActiveTerms.includes(tag))
				? filterActiveTerms.push(tag) : '';
		});

		let filterUrl = `${collectionUrl}/${(filterActiveTerms.length) ? filterActiveTerms.join('+') : ''}${(sortActiveTerm && sortActiveTerm != 'manual') ? `?sort_by=${sortActiveTerm}` : ''}`;

		// trigger ajax request for products
		collectionProductRequest = $.ajax({
			url: filterUrl,
			context: document.body
		}).done(function (data) {
			// update URL
			history.pushState({}, '', filterUrl);

			// refresh toolbar
			toolbarRefresh();

			// replace products
			if ($(data).find('#collection-products').length) {
				collectionProducts.html($(data).find('#collection-products').html());

				collectionProducts.find('[data-swatch-image].active')
					.click().trigger('mouseenter');

				$('#collection-products [data-ani-anchor]').addClass('animate');

				setTimeout(removeEditorialBlocks, 1);
			} else {
				let emptyCollectionHtml = $(data).find('#collection-empty');

				emptyCollectionHtml.find('p').html('There are no items matching your filters – reset the filters or try a different category to continue.')
					.after(`<button 
					class="btn-block" 
					data-filter-clear-trigger="all">
					Reset Filters</button>`);

				collectionProducts.html(`<div id="collection-empty">
					${emptyCollectionHtml.html()}
				</div>`);
			}

			colorFilter();

			// fade in product grid
			setTimeout(function () {
				collectionProducts.addClass('css_fadeIn')
					.removeClass('css_fadeOut');
			}, 10);

			// determine if load more is needed

			if ($(data).find('#collection-load-more').length) {
				console.log($(data));
				// if load more button already exists
				if ($('#collection-load-more').length) {
					// show load more button
					$('#collection-load-more').show();
					// and update load url
					$('#infinite-next a').attr('href', $(data).attr('href'));
				} else {
					// else, grab from new page
					collectionProducts.after(`
						${$(data).find('#collection-load-more').prop('outerHTML')}
						${$(data).find('#infinite-next').prop('outerHTML')}
					`);
				}

				productsInfiniteScroll();
			} else {
				console.log($(data));
				$('#collection-load-more').hide();
			}

			// update product counts
			let productLength = collectionProducts.find('.comp-product-card').length;

			toolbarCurrent.append(`<div 
				id="toolbar-filter-count"
				class="cr-subdued t-caption">
				${productLength} Item${(productLength > 1) ? 's' : ''}
			</div>`);

			// end loading bar
			loadingBarTrigger('done');

			// scroll to grid
			scrollTo('#collection-grid');
		});
	}

	// reset toolbar on load
	toolbarRefresh();

	_document.on('click', '[data-filter-trigger]', function () {
		let _this = $(this);

		if (_this.closest('#collection-toolbar').length ||
			_this.closest('#toolbar-mobile-filter').length) {
			_this.closest('li').toggleClass('active')
				.siblings().removeClass('active');
		} else {
			let filterTags = _this.attr('data-filter-trigger').split(',');

			// clear current active
			toolbar.find(`[data-filter-trigger]`).removeClass('active');

			// loop through clicked filter (multi-option capability.)
			for (let i = 0; i < filterTags.length; ++i) {
				// assign active state
				toolbar.find(`[data-filter-trigger="${filterTags[i]}"]`)
					.closest('li').addClass('active')
					.siblings().removeClass('active');
			}

			productRefresh();
			toolbarDropdownClose();
		}

		if (screenIsTablet) {
			let activeFilterCount = toolbarMobile.find('li.active [data-filter-trigger]').length;

			toolbarMobile.find('#toolbar-mobile-filter-apply').text((activeFilterCount > 0)
				? `Apply (${activeFilterCount})`
				: `Apply`);
		} else {
			productRefresh();
			toolbarDropdownClose();
		}
	});

	_document.on('click', '[data-sort-trigger]', function () {
		$(this).closest('li').toggleClass('active')
			.siblings().removeClass('active');

		productRefresh();

		if (!screenIsTablet) {
			toolbarDropdownClose();
		}
	});

	_document.on('click', '[data-filter-clear-trigger]', function () {
		let term = $(this).attr('data-filter-clear-trigger');

		(term == 'all')
			// clear all filtering, reload page because we can't reverse removeEditorialBlocks();
			? window.location.href = collectionUrl

			// clear individual filter
			: $(`li.active [data-filter-trigger="${term}"]`).closest('li')
				.removeClass('active');

		productRefresh();
	});

	// mobile toolbar
	toolbarMobile.find('#toolbar-mobile-filter-trigger').click(function () {
		html.toggleClass('toolbar_mobile_filter_active');

		scrollTo('#toolbar-mobile-trigger');
	});

	toolbarMobile.find('#toolbar-mobile-filter-cancel').click(function () {
		html.removeClass('toolbar_mobile_filter_active')
	});

	toolbarMobile.find('#toolbar-mobile-filter-apply').click(function () {
		html.removeClass('toolbar_mobile_filter_active');
		productRefresh();
	});

	toolbarMobile.find('#toolbar-mobile-sort-trigger').change(function () {
		html.removeClass('toolbar_mobile_filter_active');

		$(`[data-sort-trigger="${toolbarMobile.find('#toolbar-mobile-sort-trigger').val()}"]`).click();
	});
}

const imageHideBasedOnSizeTabs = () => {
	const heroImagesListImage = $('#hero-images-featured-interior [data-image]');
	const heroImagesFeaturedImages = $('#hero-images-featured .image');
	let variantActive = $('.variant-banner.active');
	let variantText = variantActive.text().trim();
	imageShowIndex = [];
	imageHasSizeIndex = [];

	if (variantText.includes('X-Large')) {
		variantText = '2X'
	} else if (variantText.includes('X-Small') || variantText.includes('Small') || variantText.includes('Medium') || variantText.includes('Large')) {
		variantText = 'XS'
	}

	heroImagesListImage.each(function (i) {
		let alt = $(this).attr('data-image-alt');
		let altSize = alt.substring(
			alt.lastIndexOf(':') + 1,
			alt.lastIndexOf('@')).split(',');
		let altSizes = altSize + ''
		altSizes = altSizes.split(',')

		if (altSize[0] && !altSize[0].includes('iframe')) {
			imageHasSizeIndex.push(i);

			if (altSizes.length > 0) {
				for (let j = 0; j < altSizes.length; j++) {
					if (variantText.includes(altSizes[j])) {
						imageShowIndex.push(i);
						break;
					}
					if (altSize.includes(variantText)) {
						imageShowIndex.push(i);
					}
				}

			}
		}

	});

	heroImagesListImage.each(function (i) {
		let _this = $(this);

		if (_this.parent().is('hidden')) _this.unwrap();
		_this.removeClass('hidden');
		
		if (imageShowIndex.length) {
			if (!imageShowIndex.includes(i)) {
				_this.addClass('hidden');
				_this.wrap('<hidden>');
			}
		} else if (imageHasSizeIndex.includes(i)) {
			_this.addClass('hidden');
			_this.wrap('<hidden>');
		}
	});

	if (screenIsTablet) {
		let heroImagesFeaturedInterior = $('#hero-images-featured-interior');

		if (heroImagesFeaturedInterior.hasClass('flickity-enabled')) {
			heroImagesFeaturedInterior.flickity('destroy');
		}

		heroImagesFeaturedInterior.flickity({
			cellAlign: 'center',
			cellSelector: '.image:not(.hidden)',
			wrapAround: true,
			prevNextButtons: false,
			pageDots: false,
			draggable: true,
			freeScroll: true
		});
	}
}

const initProductSingle = () => {
	// images
	const heroImagesListImage = $('#hero-images-featured-interior [data-image]');
	const heroImagesFeaturedImages = $('#hero-images-featured .image');

	const imageHideBasedOnSize = () => {
		let variantActive = $('.product-variants [data-variant-id].active');
		imageShowIndex = [];
		imageHasSizeIndex = [];

		heroImagesListImage.each(function (i) {
			let alt = $(this).attr('data-image-alt');
			let altSize = alt.substring(
				alt.lastIndexOf(':') + 1,
				alt.lastIndexOf('@')).split(',');
			if (altSize[0] && !altSize[0].includes('iframe')) {
				imageHasSizeIndex.push(i);

				if (altSize.includes(variantActive.text().trim())) {
					imageShowIndex.push(i);
				}
			}
		});

		heroImagesListImage.each(function (i) {
			let _this = $(this);

			if (_this.parent().is('hidden')) _this.unwrap();
			_this.removeClass('hidden');

			if (imageShowIndex.length) {
				if (!imageShowIndex.includes(i)) {
					_this.addClass('hidden');
					_this.wrap('<hidden>');
				}
			} else if (imageHasSizeIndex.includes(i)) {
				_this.addClass('hidden');
				_this.wrap('<hidden>');
			}
		});

		if (screenIsTablet) {
			let heroImagesFeaturedInterior = $('#hero-images-featured-interior');

			if (heroImagesFeaturedInterior.hasClass('flickity-enabled')) {
				heroImagesFeaturedInterior.flickity('destroy');
			}

			heroImagesFeaturedInterior.flickity({
				cellAlign: 'center',
				cellSelector: '.image:not(.hidden)',
				wrapAround: true,
				prevNextButtons: false,
				pageDots: false,
				draggable: true,
				freeScroll: true
			});
		}
	}
	const imageZoomMobileTrigger = () => {
		if (screenIsTablet) {
			let documentClick;
			heroImagesListImage.on('touchstart', function() {
				documentClick = true;
			});
			heroImagesListImage.on('touchmove', function() {
				documentClick = false;
			});
			heroImagesListImage.on('touchend', function(event) {
				if (documentClick){
					const _this = $(this);
					const imgElement = $('#zoom-mobile-popup-img');
					const videoElement = $('#zoom-mobile-popup-video');
					imgElement.hide();
					videoElement.hide()
					const imageAlt = _this.attr('data-image-alt');

					if(imageAlt.includes('<iframe')) {
						videoElement.html(imageAlt);
						videoElement.show()
					} else {
						const imageSrc = _this.find("img").attr('data-src');
						imgElement.attr('src', imageSrc);
						imgElement.show();
					}
					html.addClass('zoom_mobile_popup_active');
				}
			});
			
			pinchZoom(document.getElementById('zoom-mobile-popup-img'));
		}
	}

	const zoomMobilePopupCloseTrigger = () => {
		html.removeClass('zoom_mobile_popup_active');
	}

	$('#zoom-mobile-popup-close').click(zoomMobilePopupCloseTrigger);
	$('#zoom-mobile-popup').click(zoomMobilePopupCloseTrigger);

	heroImagesListImage.click(function () {
		let _this = $(this);

		_this.addClass('active')
			.siblings().removeClass('active');

		$(heroImagesFeaturedImages[_this.attr('data-image')])
			.addClass('active')
			.siblings().removeClass('active');
	});

/* 	$('#product-hero-content [data-swatch-color][data-url]').click(function () {
		window.location.href = $(this).attr('data-url');
	}); */

	if (screenIsTablet) {
		$('#hero-images-featured-interior').removeClass('thumbnail');

		$('#hero-images-list').remove();
		$('#product-images-popup').remove();
	}
	imageHideBasedOnSizeTabs();
	imageZoomMobileTrigger()
	// imageHideBasedOnSize()
	initImageGallery();

	// product waitlist
	const heroFormSubmit = $('#product-hero-form [data-quickadd-id]');
	const waitlist = $('#product-waitlist');
	const waitlistEmail = waitlist.find('[name="product-waitlist-email"]');
	const waitlistVariantId = waitlist.find('[name="product-waitlist-variant-id"]');
	waitlist.submit(function (e) {
		e.preventDefault();

		loadingBarTrigger('start');

		if (!waitlistEmail.val() ||
			!validateEmail(waitlistEmail.val())) {

			waitlist.find('.newsletter-email-field')
				.addClass('error');
		} else {
			BIS.create(
				waitlistEmail.val(),
				waitlistVariantId.val(),
				waitlist.find('[name="product-waitlist-product-id"]').val()
			).then(function (data) {
				var msg = '';
				loadingBarTrigger('done');

				if (data.status == 'OK') {
					waitlist.addClass('success');
				} else {
					console.error(data)
				}
			});
		}
	});

	// swatches
	$('.product-variants [data-swatch-color]').mouseenter(function () {
		let _this = $(this);

		_this.closest('.product-variants').find('.product-variants-label')
			.text(_this.attr('data-swatch-color'));
	}).mouseleave(function () {
		let productVariants = $(this).closest('.product-variants');

		productVariants.find('.product-variants-label').text(
			productVariants.find('[data-swatch-color].active').attr('data-swatch-color'));
	});
	

	// sizes and other variants
	$('.product-variants [data-variant-id]').on('click change', function (e) {
		e.preventDefault();
		let _this = $(this);
		let variantId = _this.attr('data-variant-id');
		let variantPrice = _this.attr('data-variant-price');

		// assign active states
		_this.addClass('active').parent()
			.siblings().find('[data-variant-id]').removeClass('active');

		// update quickadd trigger
		_this.closest('.product-form').find('[data-quickadd-id]')
			.attr('data-quickadd-id', variantId);

		// update pricing
		$('#hero-price-review .price').text(variantPrice);
		$('#sticky-header-cta .price').text(variantPrice);

		// determine inventory state, to reveal waitlist
		if (_this.hasClass('sold-out')) {
			heroFormSubmit.hide();
			waitlist.show().removeClass('success');
		} else {
			heroFormSubmit.show();
			waitlist.hide().removeClass('success');
		}

		// update wishlist button variant ID
		waitlistVariantId.attr('value', variantId);
		imageHideBasedOnSize();

		// sync selection with other variant selectors
		if (e.type == 'click') {
			$(`[data-variant-id="${$(this).attr('data-variant-id')}"]`).trigger('change');
		}
	});

	// accordions
	$('#hero-accordions .accordion-title').click(function () {
		$(this).siblings('.accordion-content').slideToggle()
			.closest('.accordion').toggleClass('active')
			.siblings().removeClass('active')
			.find('.accordion-content').slideUp();
	});

	// share
	const shareUrl = $('#product-share-url');
	const shareUrlSpan = shareUrl.find('span');

	shareUrl.click(function () {
		let urlInput = document.createElement('input');

		document.body.appendChild(urlInput);
		urlInput.value = window.location.href;
		urlInput.select();
		document.execCommand('copy');
		document.body.removeChild(urlInput);

		shareUrlSpan.text('Copied!');

		setTimeout(function () {
			shareUrl.mouseleave(function () {
				shareUrlSpan.text('Copy article URL');
			});
		}, 200);
	});

	// sticky header
	const stickyHeader = $('#product-sticky-header');
	const stickyHeaderSubmit = stickyHeader.find('[type="submit"]');
	const productSingleScroll = () => {
		(scrollTop > windowHeight)
			? stickyHeader.addClass('active')
			: stickyHeader.removeClass('active');
	}

	siteReadyTrigger(productSingleScroll);
	_window.scroll(productSingleScroll);

	stickyHeader.find('.selection').each(function () {
		let selection = $(this);
		let label = selection.find('.selection-label');

		// set label to the selected variant on load
		label.html(selection.find('li.active').html());

		// if only has one option, remove dropdown and caret
		if (selection.find('li').length == 1) {
			selection.addClass('single-option')
				.find('ul').remove();
		}

		// reveal dropdown
		label.click(function () {
			selection.toggleClass('active');
		});

		// list item selection
		selection.find('li').on('click change', function (e) {
			let _this = $(this);

			// assign active state
			selection.removeClass('active');

			_this.addClass('active')
				.siblings().removeClass('active');

			if (_this.attr('data-variant-url')) {
				window.location.href = _this.attr('data-variant-url');
			} else {
				label.html(_this.html());

				stickyHeaderSubmit.attr('data-quickadd-id',
					_this.attr('data-variant-id'));
			}

			(_this.hasClass('sold-out'))
				? stickyHeader.find('[type="submit"]').addClass('btn-block-outline').text('Sold Out')
				: stickyHeader.find('[type="submit"]').removeClass('btn-block-outline').text('Add to Bag')

			// sync selection with other variant selectors
			if (e.type == 'click') {
				$(`[data-variant-id="${$(this).attr('data-variant-id')}"]`).trigger('change');
			}
		});
	});

	_window.click(function (e) {
		let target = $(e.target);

		if (stickyHeader.find('.selection.active').length &&
			!target.hasClass('selection') &&
			!target.closest('.selection').length) {
			stickyHeader.find('.selection.active')
				.removeClass('active');
		}
	});
}

const initSizeGuide = () => {
	const guideOpen = $('.size-guide-open');
	const guideClose = $('.size-guide-close, .size-guide-overlay');
	const fitSelector = $('#size-guide-fit-selector');
	const tabSelector = $('[data-size-chart-tabs-trigger]');

	guideOpen.click(function () {
		html.addClass('size_guide_active');
	});

	guideClose.click(function () {
		html.removeClass('size_guide_active');
	});

	fitSelector.change(function () {
		$('[data-fit].active').removeClass('active');
		$(`[data-fit="${fitSelector.val()}"]`).addClass('active');
	});

	tabSelector.click(function () {
		let _this = $(this);

		_this.closest('li').addClass('active')
			.siblings().removeClass('active');

		$(`[data-size-chart-tabs="${_this.attr('data-size-chart-tabs-trigger')}"]`).addClass('active')
			.siblings().removeClass('active');
	});
}

const initCart = () => {
	const minicartTrigger = $('#minicart-trigger');
	const minicartClose = $('#minicart-close, #minicart-overlay');

	const itemGiftBoxExclude = () => {
		let item = (html.is('#cart'))
			? $('#cart-content .item')
			: $('#minicart-content .item');

		// hide gift item if cart only contains digital gift card
		if (item.length == 2 &&
			item.attr('data-product-title') == 'Digital Gift Card') {
			$('#cart-giftbox, .comp-giftbox').hide();
			$('.gift-note-clear').click();

			if ($('#giftbox-add').prop('checked') == true) {
				$('#giftbox-add').click();
			}
		} else {
			$('#cart-giftbox, .comp-giftbox').show();
		}
	}

	const cartTotalUpdate = () => {
		/* let totalPrice = $('.cart-total-price');
		let itemCount = $('.cart-item-count'); */
		let cartTotalPrice = $('.cart-total-price-2');
		let cartItemCount = $('.cart-item-count-2');		
		let item = (html.is('#cart'))
			? $('#cart-content .item')
			: $('#minicart-content .item')

		totalPriceChange = totalItemCount = 0;

		// loop through each item
		item.each(function () {
			let item = $(this);

			// There was an error that showed NaN for wanting to capture the number of a string with a method that did not consider all the options, a regular expression was used to solve this.

			let itemQuantity = item.find('.item-quantity-current').length
				? parseInt($(item.find('.item-quantity-current')[0]).text().match(/(\d+)/g)[0]) 
				: (item.is('#cart-giftbox'))
					? $('#giftbox-add').prop('checked') == true
						? 1
						: 0
					: 1;
			
			let itemPrice = item.find('.item-price').length
				? parseInt(item.find('.item-price').text().replace(/[^0-9&.]/g, ''))
				: item.attr('data-item-price');

			// multiply price and quantity, and add to total value
			totalPriceChange += itemPrice * itemQuantity;
			totalItemCount += itemQuantity;
		});

		// clear gift item if it's the only one left in cart
		if ($('#giftbox-add').length &&
			$('#giftbox-add').prop('checked') == true) {
			totalItemCount = totalItemCount - 1;
		}

		itemGiftBoxExclude();

		// update cart total values
		cartTotalPrice.text(`$${formatCommify(totalPriceChange)}`);
		cartItemCount.text(totalItemCount);

		// determine whether item exists
		if (totalItemCount == 0) {
			minicartTrigger.removeClass('has_items');
			$('#cart-content, #minicart').removeClass('has_items');

			$.post(`/cart/update.js?updates[${$('#cart-giftbox').attr('data-item-id')}]=0`);
		} else {
			minicartTrigger.addClass('has_items');
			$('#cart-content, #minicart').addClass('has_items');
		}

		jQuery.getJSON('/cart.js', function (cart) {
			$('.cart-item-count').html(cart.item_count)
			$('.cart-total-price').html('$'+(cart.total_price/100).toFixed(2));
		})
	}

	const itemUpdate = (item, qty, funk) => {
		$.post(`/cart/update.js?updates[${item.attr('data-item-key')}]=${qty}`).always(function (data) {
			let dataItems = JSON.parse(data.responseText).items || null;

			// simon data integration
			if (dataItems) {
				let sdItemsArray = [];
				$.each(dataItems, function (index, item) {
					sdItemsArray.push({
						productId: item.product_id,
						variant: item.variant_id,
						quantity: item.quantity,
						productImageUrl: item.image,
						productUrl: window.location.origin + item.url,
						brand: 'Lunya',
						category: item.product_type,
						color: item.options_with_values[0]['value'],
						productName: item.product_title,
						price: parseInt(item.price / 100),
						properties: { desc: '' }
					});
				});

				sd.track('update_cart', {
					productId: item.attr('data-product-id'),
					variant: item.attr('data-item-id'),
					quantity: qty,
					productImageUrl: item.find('.item-thumbnail img').attr('src'),
					productUrl: item.find('.item-thumbnail img').attr('href'),
					brand: 'Lunya',
					category: item.attr('data-product-type'),
					color: item.find('.item-info-variants option:selected').text().split(' | ')[0].trim(),
					productName: item.attr('data-product-title'),
					price: parseInt(item.attr('data-item-price').replace(',', '')),
					properties: { desc: '' },
					cartItems: sdItemsArray
				});
			}

			//  klarna integration
			$('.klarna-minicart, .klarna-cart').attr('data-purchase_amount', parseInt($('.cart-total-price').text().replace(/\D/g, '')) * 100);

			setTimeout(function () {
				window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
				window.KlarnaOnsiteService.push({
					eventName: 'refresh-placements'
				});
			}, 10);

			if (item.data('product-emb')) {
				let productEmb = $(`[data-item-id=${item.attr('data-product-emb')}][data-product-emb]`);
				$.post(`/cart/update.js?updates[${productEmb.attr('data-item-key')}]=0`).always(function (data) {
					productEmb.remove();
					if (!document.URL.includes("/cart")) {
						cartReload(true,false)
					}
					else {
						cartReload(false,true)
					}
				})
			}

/* 			if (item.is('[data-product-emb]') && qty == 0) {
				$.post(`/cart/update.js?updates[${item.attr('data-product-emb')}]=0`)
				$(`[data-item-id="${item.attr('data-product-emb')}"]`).remove();
			} */
			// execute callback function
			if (funk) {
				funk();
				loadingBarTrigger('move');
			} else {
				setTimeout(cartTotalUpdate, 301);
				loadingBarTrigger('done');
			}
			var product_id = item.attr('data-product-id');
			var variant = item.attr('data-item-id');

			updateGiftBoxControl(variant);
			if (frgiSystem) {
			if (!document.URL.includes("/cart")) {
				controlGiftSystemUpdate(true, false);
			}
			else {
				controlGiftSystemUpdate(false, true)
			}
		}

		});
	}

	// control the giftbox to the updated item, if has "no-giftbox" it is not elegible.
	const updateGiftBoxControl = (variant) => {
		const noGiftProducts = getJsonCollection('no-giftbox');
		controlAddNote();

		noGiftProducts.then(function (result) {
			noGiftIds = [];
			for (let i = 0; i < result.length; i++) {
				noGiftIds.push(result[i].id);
			}
			jQuery.getJSON('/cart.js', function (cart) {
				var control = [];
				let hasNoGift = false;
				for (let i = 0; i < cart.items.length; i++) {
					if (noGiftIds.includes(cart.items[i].product_id)) {
						hasNoGift = true;
						control[i] = true;
					}
					else if (cart.items[i].product_id != 4324587044907) {
						control[i] = false;
					}
				}

				controlNoGift = true;

				for (let i = 0; i < control.length; i++) {
					if (control[i] == false) {
						controlNoGift = false;
					}
				}

				if (controlNoGift) {
					jQuery.post('/cart/update.js', { updates: { 31272537948203: 0 } });
					$('.item').filter('[data-product-title="Gift Box"]').remove();
					$('#giftbox-label').css('color', '#babbbb');
					$('#giftbox-add').prop('disabled', true);
					$('#giftbox-add').prop('checked', false);
					$('#giftbox-add').css('background-color', '#f4f5f6');
					$('#giftbox-add').css('border', '1px solid #babbbb');
					document.getElementById("circle").setAttribute("stroke", "#babbbb");
					document.getElementById("question").setAttribute("fill", "#babbbb");
					$('#giftbox-button').prop('disabled', true);
					$('.giftbox-not-available').css('display', 'none');
					$('#giftbox-footer-label').css('display', 'block');
				}
				else {
					$('#giftbox-label').css('color', 'black');
					$('#giftbox-add').prop('disabled', false);
					$('#giftbox-add').css('background-color', 'white');
					document.getElementById("circle").setAttribute("stroke", "#000000");
					document.getElementById("question").setAttribute("fill", "#000000");
					//$('#giftbox-button').prop('disabled', false);
					//$('#giftbox-button').prop('color', "#000000");
				}

				if(hasNoGift) $('#giftbox-footer-label').css('display', 'block');

				// check if elements of the cart is on no-giftbox, if false hide the giftbox-footer
				let check = cart.items.every(function (e) {
					return noGiftIds.includes(e.product_id);
				});
				if (!check) $('#giftbox-footer-label').css('display', 'none');
			});
			if (!document.URL.includes("/cart")) {
				$('.nogift').css('display', 'none');
			}
		});

		if (variant == 31272537948203) {
			$('#giftbox-add').prop('checked', false);
		}
	}

	const cartReload = (openCart, reloadPage, variantId = 0) => {
		
		jQuery.getJSON('/cart.js', function (cart) {
			let freeCartProducts1 = document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]') ? document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]') : null;
			let freeCartProducts2 = document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]') ? document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]') : null;

				if (cart.item_count < 1) { 
					freeCartProducts1.forEach(element => {
						element.remove();
					});
					freeCartProducts2.forEach(element => {
						element.remove();
					}); 
				}
			})

		$.ajax({
			url: '/cart',
			dataType: 'html',
			error: function (data) {
				console.error(data);

				loadingBarTrigger('done');
			},
			success: function (data) {
				let minicartContent = $('#minicart-content');
				let cartItemsHtml = $(data).find('#cart-content #cart-items').html();
				
				// insert or prepend cart HTML
				(minicartContent.find('#cart-items').length)
					? minicartContent.find('#cart-items').html(cartItemsHtml)
					: minicartContent.prepend(cartItemsHtml);

				// remove giftbox content if exists
				(minicartContent.find('#cart-giftbox .item-info').length)
					? minicartContent.find('#cart-giftbox .item-info').remove()
					: '';

				loadingBarTrigger('done');
				cartTotalUpdate();

				// open cart
				(openCart && !html.is('#cart'))
					? minicartTrigger.trigger('click') : '';

				(reloadPage)
					? location.reload() : '';

				$('.nogift').css('display', 'none');

				if (!document.URL.includes("/cart")) {
					if (variantId == 31272537948203) {
						if ($('#giftbox-add').prop('checked') == true) {
							$('.giftbox-notes').slideDown();
						}
						else {
							$('.giftbox-notes').slideUp();
						}
					}
				}

				let freeCartProducts1 = document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]') ? document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]') : null;
				let freeCartProducts2 = document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]') ? document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]') : null;

				freeCartProducts1.forEach(element => {
					let qty = element.querySelector('.item-quantity')
					let qtyContainer = element.querySelector('.item-quantity-container')
					let hrefGift = element.querySelector('.object-fit')
					qty.style.display = 'none'
					qtyContainer.style.display = 'none'
					hrefGift.href = 'javascript:void(0)'
				});
				freeCartProducts2.forEach(element => {
					let qty = element.querySelector('.item-quantity')
					let qtyContainer = element.querySelector('.item-quantity-container')
					let hrefGift = element.querySelector('.object-fit')
					qty.style.display = 'none'
					qtyContainer.style.display = 'none'
					hrefGift.href = 'javascript:void(0)'
				}); 


			}
		});

		
	}
	
	const itemAdd = (variantId, qty, openCart, reloadPage, _this) => {
		if(_this && _this.is('[data-embroidery]')) {
		if (_this.is('[data-embroidery]')) {
			$.ajax({
				type: 'POST',
				dataType: 'html',
				url: `/cart/add.js`,
				data: {
					items: [
						{
						id: variantId,
						quantity: qty,
						properties: {
							'embroidery text': _this.attr('data-embroidery'),
							'embroidery-id': _this.attr('data-product-id'),
							'embroidery-color': _this.attr('data-embroidery-color')
						}
						},
						{
						id: _this.attr('data-product-id'),
						quantity: qty,
						properties: {
							'embroidery text': _this.attr('data-embroidery'),
							'embroidery-id': _this.attr('data-quickadd-id'),
							'embroidery-color': _this.attr('data-embroidery-color')
						}
						}
						],
				},
				error: function (data) {
					console.error(data);
	
					loadingBarTrigger('done');
				},
				success: function () {
					yieldATC(variantId, qty, _this);
					loadingBarTrigger('move');
					cartReload(openCart, reloadPage, variantId);
					updateGiftboxControl(variantId);
					if (frgiSystem) {
						controlGiftSystemUpdate(openCart, reloadPage);
					}
				}
			});
			}
		}
		else{
		if (variantId != 31272537948203) {
			jQuery.getJSON('/cart.js', function (cart) {
/* 				let allEmb = true;
				for (let i = 0; i < cart.items.length; i++) {
					const item = cart.items[i]
					console.log(item)
					if (item.properties) {
						if(item.product_id != 4324587044907 && !item.properties["embroidery-id"]) {
							allEmb = false;
						}
					}
				}
 */
				function checkGiftbox(item) {
					return item.product_id == 4324587044907
				}

				let hasGiftbox = cart.items.some(checkGiftbox)

				if (hasGiftbox) {
					$.ajax({
						type: 'POST',
						dataType: 'html',
						url: `/cart/add.js`,
						data: {
							id: variantId,
							quantity: qty
						},
						error: function (data) {
							console.error(data);
							loadingBarTrigger('done');
						},
						success: function () {
							yieldATC(variantId, qty, _this);
							loadingBarTrigger('move');
							cartReload(openCart, reloadPage, variantId);
							updateGiftboxControl(variantId);
							if (frgiSystem) {
								controlGiftSystemUpdate(openCart, reloadPage);
							}
							removeGiftbox()
						}
					});
				}
				else {
					$.ajax({
						type: 'POST',
						dataType: 'html',
						url: `/cart/add.js`,
						data: {
							id: variantId,
							quantity: qty
						},
						error: function (data) {
							console.error(data);
		
							loadingBarTrigger('done');
						},
						success: function () {
							yieldATC(variantId, qty, _this);
							loadingBarTrigger('move');
							cartReload(openCart, reloadPage, variantId);
							updateGiftboxControl(variantId);
							if (frgiSystem) {
								controlGiftSystemUpdate(openCart, reloadPage);
							}
						}
					});
				}
		})
		}
		else {
			jQuery.getJSON('/cart.js', function (cart) {
				let allEmb = true;
				for (let i = 0; i < cart.items.length; i++) {
					const item = cart.items[i]
					if (item.properties != null) {
					if(item.product_id != 4324587044907 && !item.properties["embroidery-id"]) {
						allEmb = false;
					}
					}
					else {
						allEmb = false;
					}
				}
	
				if (allEmb) {
					$.ajax({
						type: 'POST',
						dataType: 'html',
						url: `/cart/add.js`,
						data: {
							id: variantId,
							quantity: qty,	
							properties: {
								'embroidery': " ",
								"embroidery-id" : "embroidery"
							}
						},
						error: function (data) {
							console.error(data);
							loadingBarTrigger('done');
						},
						success: function () {
							yieldATC(variantId, qty, _this);
							loadingBarTrigger('move');
							cartReload(openCart, reloadPage, variantId);
							updateGiftboxControl(variantId);
							if (frgiSystem) {
								controlGiftSystemUpdate(openCart, reloadPage);
							}
						}
					});
				}
				else {
					$.ajax({
						type: 'POST',
						dataType: 'html',
						url: `/cart/add.js`,
						data: {
							id: variantId,
							quantity: qty
						},
						error: function (data) {
							console.error(data);
			
							loadingBarTrigger('done');
						},
						success: function () {
							yieldATC(variantId, qty, _this);
							loadingBarTrigger('move');
							cartReload(openCart, reloadPage, variantId);
							updateGiftboxControl(variantId);
							if (frgiSystem) {
								controlGiftSystemUpdate(openCart, reloadPage);
							}
						}
					});
				}
	
			})
		}
		}
	}

	const removeGiftbox = () => {
		jQuery.getJSON('/cart.js', function (cart) {
			let allEmb = true;
			for (let i = 0; i < cart.items.length; i++) {
				const item = cart.items[i]
				if (item.properties != null) {
					if(item.product_id != 4324587044907 && !item.properties["embroidery-id"] ) {
						allEmb = false;
					}
				}
				else {
					allEmb = false;
				}
			}
		jQuery.post('/cart/update.js', { updates: { 31272537948203: 0 } });

		if (document.URL.includes("/cart")) {
			itemAdd('31272537948203', 1, false, true);
		} else {
			itemAdd('31272537948203', 1, true, false);
		}
		})
	}

	const yieldATC = (variantID, qty, _this) => {
      
		let globalEData = getCookie('GlobalE_Data');
		let userCurrency;
		
		if (globalEData == null) {
		  userCurrency = 'USD';
		} else {
		  let globalEParsed = JSON.parse(globalEData);
		  userCurrency = globalEParsed['currencyCode'];
		}
		
		let pdpSelector = $('.product-variants .active[data-variant-id]');
		
		let variantSku;
		let variantDYPrice;
		
      // First, check if gift. Next, check if PLP or PDP. Then, check currency.
      if (variantID == '31272537948203') {
        variantSku = 'GIFTBOX1-WHT-OS';
        variantDYPrice = $('#giftbox-label').text();
        variantDYPrice = Number(variantDYPrice.replace(/[^0-9\.-]+/g,""));
      } else {
        if (pdpSelector.length > 0) {
          variantSku = pdpSelector.attr('data-variant-sku');
          if (userCurrency == 'USD') {
            variantDYPrice = pdpSelector.attr('data-variant-dy-price');
          } else {
            variantDYPrice = $('#hero-price-review .price').text();
            variantDYPrice = Number(variantDYPrice.replace(/[^0-9\.-]+/g,""));
          }
        } else {
          variantSku = _this.attr('data-variant-sku');
          if (userCurrency == 'USD') {
            variantDYPrice = _this.attr('data-variant-dy-price');
          } else {
            variantDYPrice = _this.closest('.comp-product-card').find('.product-price').text();
            variantDYPrice = Number(variantDYPrice.replace(/[^0-9\.-]+/g,""));
          }
        }
      }
		
		DY.API("event", {
		  name: "Add to Cart",
		  properties: {
			dyType: "add-to-cart-v1",
			value: variantDYPrice,
			currency: userCurrency,
			productId: variantSku,
			quantity: qty
		  }
		});
		
	}

	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
		  var c = ca[i];
		  while (c.charAt(0) == ' ') {
			c = c.substring(1);
		  }
		  if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		  }
		}
		return null;
	}

	if (frgiSystem) {
		if (productId1) {
			let freeCartProducts1 = document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]');

			if (freeCartProducts1) {
				freeCartProducts1.forEach(element => {
					let qty = element.querySelector('.item-quantity')
					let qtyContainer = element.querySelector('.item-quantity-container')
					let hrefGift = element.querySelector('.object-fit')
					qty.style.display = 'none'
					qtyContainer.style.display = 'none'
					hrefGift.href = 'javascript:void(0)'
				});
			}
		}
		if (productId2) {
			let freeCartProducts2 = document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]');

			if (freeCartProducts2) {
				freeCartProducts2.forEach(element => {
					let qty = element.querySelector('.item-quantity')
					let qtyContainer = element.querySelector('.item-quantity-container')
					let hrefGift = element.querySelector('.object-fit')
					qty.style.display = 'none'
					qtyContainer.style.display = 'none'
					hrefGift.href = 'javascript:void(0)'
				});
			}
		}
	}

	
	const itemUpdateKey = (key, qty) => {
		$.post(`/cart/update.js?updates[${key}]=${qty}`, function () {
			console.log(" success");
		})
			.fail(function (e) {
				console.log(e)
			})
	}

	const itemUpdateGift = (key, qty, openCart, reloadPage) => {
		$.post(`/cart/update.js?updates[${key}]=${qty}`, function () {
			console.log(" success");
		})
			.fail(function (e) {
				console.log(e)
			})
			.always(function () {
				setTimeout(function () {
					cartReload(openCart, reloadPage)
					controlGiftSystemUpdate(openCart, reloadPage)
				}, 250);
			});
	}

	const controlGiftSystemUpdate = (openCart, reloadPage) => {
		
		let freeCartProducts1 = document.querySelectorAll('[data-product-id="' + productId1 + '"][data-item-price="0.00"]');
		let freeCartProducts2 = document.querySelectorAll('[data-product-id="' + productId2 + '"][data-item-price="0.00"]');
		let totalDigitalCards, cartTotal = 0;
		let qty1, qty2 = 0;


		jQuery.getJSON('/cart.js', function (cart) {
			cartTotal = cart.total_price;
			for (let i = 0; i < cart.items.length; i++) {
				if (cart.items[i].product_id == 4844103532587) {
					totalDigitalCards = totalDigitalCards + cart.items[i].original_line_price;
				}
/* 			 	if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift1) && (cart.items[i].total_discount == 0)) {
					cartTotal = cartTotal - cart.items[i].line_price
				} */
				if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift1)) {
					qty1 =cart.items[i].quantity
				} 
				if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift2) && (cart.items[i].total_discount == 0)) {
					cartTotal = cartTotal - cart.items[i].line_price
				} 
				else if((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift2) && (cartTotal<250)) {
					cartTotal = cartTotal - cart.items[i].line_price
				}
				if ((cart.items[i].properties["isgift"] == "yes") && (cart.items[i].variant_id == variantGift2)) {
					qty2 =cart.items[i].quantity
				
				} 
			}
			if (totalDigitalCards > 0) {
				cartTotal = cartTotal - totalDigitalCards;
			}

			if (cartTotal >= (prd1Min * 100) && cartTotal < (prd1Max * 100)) {
				if (freeCartProducts2.length > 0) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift2) && (cart.items[j].quantity > 0)) {
							freeCartProducts2.forEach(element => {
								element.remove();
							});
							itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage)
							break;
						}
					}
				}
				else if (freeCartProducts1.length > 1) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift1) && (cart.items[j].quantity > 1)) {
							itemUpdateGift(cart.items[j].key, 1, openCart, reloadPage)
						}
					}
				}
				else if (freeCartProducts1.length == 0) {
					itemAddGiftUpdate(variantGift1, 1, openCart, reloadPage);
				}

			}
			else if ((cartTotal >= (prd2Min * 100)) && (cartTotal < (prd2Max * 100))) {
				let match = false;
				if (qty1 > 0)  {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift1) && (cart.items[j].quantity > 0)) {
							freeCartProducts1.forEach(element => {
								element.remove();
							});
							itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage)
							break;
						}
					}
				}
				else if (freeCartProducts2.length > 1) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift2) && (cart.items[j].quantity > 1)) {
							itemUpdateGift(cart.items[j].key, 1, openCart, reloadPage)
							break;
						}
					}
				}
				else if (freeCartProducts2.length == 0) {
					itemAddGiftUpdate(variantGift2, 1, openCart, reloadPage);
				}

			}
			else if (bothProducts && cartTotal >= (bothProductsTh * 100)) {
				if ((freeCartProducts1.length < 1)) {
					itemAddGiftUpdate(variantGift1, 1, openCart, reloadPage);
				}
				else if ((freeCartProducts1.length > 1)) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift1) && (cart.items[j].quantity > 1)) {
							itemUpdateGift(cart.items[j].key, 1, openCart, reloadPage)
							break;
						}
					}
				}
				else if ((freeCartProducts2.length < 1)) {
					itemAddGiftUpdate(variantGift2, 1, openCart, reloadPage);
				}
				else if ((freeCartProducts2.length > 1)) {
					for (let j = 0; j < cart.items.length; j++) {
						if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift2) && (cart.items[j].quantity > 1)) {
							itemUpdateGift(cart.items[j].key, 1, openCart, reloadPage)
							break;
						}
					}
				}

			}
			else if (cartTotal < (prd1Min * 100)) {
				for (let j = 0; j < cart.items.length; j++) {
					if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift1)) {
						itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage)
					}
					if ((cart.items[j].properties["isgift"] == "yes") && (cart.items[j].variant_id == variantGift2)) {
						itemUpdateGift(cart.items[j].key, 0, openCart, reloadPage)
					}
				}
			}
		});
	}

	const itemAddGiftUpdate = (variant, qty, openCart, reloadPage) => {
		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: `/cart/add.js`,
			data: {
				id: variant,
				quantity: qty,
				properties: {
					'isgift': 'yes'
				}
			},
			error: function (data) {
				console.error(data);
			},
			success: function () {
				cartReload(openCart, reloadPage);
			}
		});
	}


	// control the giftbox to the added item, if has "no-giftbox" it is not elegible.
	const updateGiftboxControl = variantId => {

		const noGiftProducts = getJsonCollection('no-giftbox');
		controlAddNote();
		noGiftProducts.then(function (result) {
			noGiftIds = [];
			for (let i = 0; i < result.length; i++) {
				noGiftIds.push(result[i].id);
			}
			jQuery.getJSON('/cart.js', function (cart) {
				var control = [];
				let hasNoGift = false;
				for (let i = 0; i < cart.items.length; i++) {
					if (noGiftIds.includes(cart.items[i].product_id)) {
						control[i] = true;
						hasNoGift = true;
					}
					else if (cart.items[i].product_id != 4324587044907) {
						control[i] = false;
					}
				}

				controlNoGift = true;

				for (let i = 0; i < control.length; i++) {
					if (control[i] == false) {
						controlNoGift = false;
					}
				}

				if (controlNoGift) {
					jQuery.post('/cart/update.js', { updates: { 31272537948203: 0 } });
					$('.item').filter('[data-product-title="Gift Box"]').remove();
					$('#giftbox-label').css('color', '#babbbb');
					$('input[name="giftboxOption"]').prop('disabled', true);
					$('input[name="giftboxOption"]').css('background-color', '#f4f5f6');
					$('input[name="giftboxOption"]').css('border', '1px solid #babbbb');
					$('.svg-tooltip #circle').css("stroke", "#babbbb");
					$('.svg-tooltip #question').css("fill", "#babbbb");
					$('#giftbox-add').prop('disabled', true);
					$('#giftbox-add').prop('checked', false);
					$('#giftbox-add').css('background-color', '#f4f5f6');
					$('#giftbox-add').css('border', '1px solid #babbbb');
					$('#giftbox-button').prop('disabled', true);
					$('.giftbox-not-available').css('display', 'none');
					$('#giftbox-footer-label').css('display', 'block');
				}
				else {
					$('#giftbox-label').css('color', 'black');
					$('input[name="giftboxOption"]').prop('disabled', false);
					$('input[name="giftboxOption"]').css('background-color', '');
					$('input[name="giftboxOption"]').css('border', '');
					$('.svg-tooltip #circle').css("stroke", "#000000");
					$('.svg-tooltip #question').css("fill", "#000000");
					//$('#giftbox-button').prop('disabled', false);
					//$('#giftbox-button').prop('color', "#000000");
				}
				if(hasNoGift) $('#giftbox-footer-label').css('display', 'block');

				// check if elements of the cart is on no-giftbox, if false hide the giftbox-footer
				let check = cart.items.every(function (e) {
					return noGiftIds.includes(e.product_id);
				});
				if (!check) $('#giftbox-footer-label').css('display', 'none');

				let check2 = cart.items.some(function (e) {
					return noGiftIds.includes(e.product_id);
				});

				if (check2) $('#giftbox-footer-label').css('display', 'block');


			});

		});
	}

	const controlGiftMsg = () => {
		const noGiftProducts = getJsonCollection('no-giftbox');
		noGiftProducts.then(function (result) {
			noGiftIds = [];
			for (let i = 0; i < result.length; i++) {
				noGiftIds.push(result[i].id);
			}
			jQuery.getJSON('/cart.js', function (cart) {
				// check if elements of the cart is on no-giftbox, if false hide the giftbox-footer
				let check = cart.items.every(function (e) {
					return noGiftIds.includes(e.product_id);
				});
				if (!check) $('#giftbox-footer-label').css('display', 'none');

				let check2 = cart.items.some(function (e) {
					return noGiftIds.includes(e.product_id);
				});

				if (check2) $('#giftbox-footer-label').css('display', 'block');


			});

		});
	}
	controlGiftMsg();

	const controlAddNote = () => {
		if ($('#giftbox-add').prop('checked') == true) {
			//$('.giftbox-notes').slideDown();
			$('#giftbox-button').prop('disabled', false);
			$('#giftbox-button').prop('color', "#000000");
		}
		else {
			$('#giftbox-button').prop('disabled', true);
		}
	}

	// reload cart if page is loaded from bfcache
	window.onpageshow = function (event) {
		if (event.persisted) {
			cartReload(false, false);
		}
	}
	
		// remove items
		_document.on('click', '.item-remove-kit', function () {
			let _this = $(this);
			console.log($(this).attr('data-kit-name-order'))
			console.log("_this")
			console.log(_this)
			let kitName = $(this).attr('data-kit-name')
			let kitNameOrder = $(this).attr('data-kit-name-order')
			let items = $('.item[data-kit-name-order='+kitNameOrder+']')
			let removeSection = $('.remove-section[data-kit-name-order='+kitNameOrder+']')
			itemsId = []
			let updateString = ''
			items.each(function (index, value) {
				updateString = updateString.concat("updates["+$(this).attr('data-item-id')+"]=0&")
			})
			console.log("update string")
			console.log(updateString)
			loadingBarTrigger('start');
			let openCart = (!_this.closest('#minicart-content').length) ? true : false
			let reloadPage =  (_this.closest('#cart-related').length) ? true : false
			$.post('/cart/update.js',updateString).always(function (data) {
				loadingBarTrigger('move');
				cartReload(openCart, reloadPage);
				removeKits(items,removeSection)
			  }) 
			});
	
		const removeKits = (items,removeSection) => {
			removeSection.remove();
			items.each(function () {
				$(this).remove();
			})
	
		}

	// quick add
	_document.on('click', '[data-quickadd-id]', function () {
		let _this = $(this);
		let emb = $('#embroidery')
		let color = $('#swatch-emb button.active')
		if(emb.val() != '' && emb.is(":visible") ) {
			_this.attr('data-embroidery',emb.val())
			_this.attr('data-embroidery-color',color.attr('data-swatch-color-emb').toUpperCase())
		}

		if (_this[0].classList.contains('sold-out')) {
			waitlistModal.style.display = 'block'
			initWaitlistvalues(_this);
		}
		else {
			loadingBarTrigger('start');

			itemAdd(_this.attr('data-quickadd-id'), 1,
				(!_this.closest('#minicart-content').length) ? true : false,
				(_this.closest('#cart-related').length) ? true : false,
				_this
			);
		}
	});

	String.prototype.replaceAll = function(search, replacement) {
		var target = this;
		return target.replace(new RegExp(search, 'g'), replacement);
	};

	_document.on('click', '.swatch-btn', function () {
		let _this = $(this);
		let handle = _this.attr('data-swatch-handle')
		let colorSelected = _this.attr('data-swatch-color')
		let img = _this.closest('.product-kit-item').find('img');
		let newImg = _this.attr('data-swatch-image')
		let sizes = $('.size-kit[data-kit-handle="'+handle+'"]')
		let addKit = $('#add-to-cart-kit')
		let kit_product = kitProducts.find(kit => kit.handle == handle)
		let kit_variants = kit_product.variants.filter(variant => variant.option1 == colorSelected)
		img.attr('data-src',newImg)
		img.attr('data-srcset',newImg)
		img.attr('src',newImg)
		img.attr('srcset',newImg)
		sizes.each(function () {
			let sizeValue = $(this).attr('data-variant-value')
			let variantSelected = kit_variants.find(variant => variant.option2 == sizeValue)
			if (variantSelected) {
				if (!variantSelected.available ) {
					$(this).addClass('sold-out')
					$(this).removeClass('active')
					$(this).next().find('.cr-red').removeClass('hide')
				} else {
					$(this).removeClass('sold-out')
					$(this).next().find('.cr-red').addClass('hide')
				}
			}
			$(this).removeClass('active')
		})
		let firstSize = $('.size-kit[data-kit-handle="'+handle+'"]:not(.sold-out)').first();
		if (firstSize.length != 0) {
			firstSize.addClass('active')
		}
		else {
			$('.size-kit[data-kit-handle="'+handle+'"]').first().addClass('active');
		}
		let allSizes = $('.size-kit.active');
		if (allSizes.length <= 1) {
			addKit.prop('disabled',true);
		}
		else {
			addKit.prop('disabled',false);
		} 

	})

	_document.on('click', '.size-kit', function () {
		if ($(this).hasClass('sold-out')) {
		}
		let allSizes = $('.size-kit.active');
		let addKit = $('#add-to-cart-kit')
		if (allSizes.length <= 1) {
			addKit.prop('disabled',true);
		}
		else {
			addKit.prop('disabled',false);
		} 
	})
	// quick add KIT
	_document.on('click', '[data-quickadd-kit-id]', function () {
		let _this = $(this);
		let productForms = $('.product-kit-form')
		let productKitIds = []
		let kit_key = new Date().valueOf();
		productForms.each(function (index) {
			let color = $(this).find('.swatch-btn.active').attr('data-swatch-color')
			let size = $(this).find('.size-btn.active').attr('data-variant-value')
			let handle =  $(this).attr('data-product-kit-name').replaceAll(' ','-')
			let realHandle = $(this).attr('data-product-handle')
			let match =false;
			for (let i = 0; i < kitProducts.length; i++) {
				for (let j = 0; j  < kitProducts[i].variants.length; j++) {
					let variant = kitProducts[i].variants[j]
					if (variant.option1 == color && variant.option2 == size &&  kitProducts[i].handle == realHandle) {
						productKitIds.push({id: variant.id, qty: 1,properties: {"kitkey": kit_key, "kitindex": index,'iskit': 'yes', 'kitname': handle}})
						match = true;
						break;
					}
				}
				if (match) {
					break;
				}
			}
		})

		let openCart = (!_this.closest('#minicart-content').length) ? true : false
		let reloadPage =  (_this.closest('#cart-related').length) ? true : false
		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: `/cart/add.js`,
			data: { items: productKitIds },
			error: function (data) {
				console.error(data);
				loadingBarTrigger('done');

			},
			success: function (data) {
				loadingBarTrigger('move');
				cartReload(openCart, reloadPage);
				setTimeout(function(){
				cartKitName(data)
				}, 1000);
			}
		});
	});

	const cartKitName = (data) => {
		let productForms = $('.product-kit-form')
		let dataItems = JSON.parse(data)
		if (productForms.length > 0) {
			productForms.each(function () {
				let kitHandle = $(this).attr('data-product-kit-name').replaceAll(' ','-')
				let kitClasses = $(`.cart-kit-name--${kitHandle}`);
				kitClasses.first().removeClass('hide')
			})
		}
	}

	//control giftcard qty 
	/* 	const updateGiftCardControl = () => {
			jQuery.getJSON('/cart.js', function (cart) {
				for (let i = 0; i < cart.items.length; i++) {
					if (cart.items[i].product_id == 4844103532587 && cart.items[i].quantity > 50) {
						$('#giftcard-qty2').css('display','inline-block');
						if (document.URL.includes("/cart")) {
							$('#giftcard-qty').css('display','inline-block');
						}
					}
				}
			});
		}
	
		updateGiftCardControl(); */

	// item quantity adjustments
	_document.on('click', '.item-quantity button', function (e) {
		e.preventDefault();
		
		let _this = $(this);
		let item = _this.closest('.item');
		let itemProductID = item.attr('data-product-id');
		let itemQuantity = _this.closest('.item-quantity');
		let quantityMax = itemQuantity.attr('data-quantity-max');
		let quantityMin = itemQuantity.attr('data-quantity-min');
		let quantityCurrent = _this.siblings('.item-quantity-current');
		let quantityCurrentVal = quantityCurrent.text()
			? parseInt(quantityCurrent.text())
			: parseInt(quantityCurrent.val());
		let quantityAction = _this.hasClass('item-quantity-increase')
			? 'increase'
			: 'decrease';

		if (frgiSystem) {
			$('#qty-plus').prop('disabled', true);
			$('#qty-minus').prop('disabled', true);
		}
		// if increase, and isn't max inventory count
		let quantityNewVal = quantityAction == 'increase' && quantityCurrentVal < quantityMax
			// increase quantity
			? quantityCurrentVal + 1
			// else if is decrease and quantity isn't 0
			: quantityAction == 'decrease' && quantityCurrentVal > quantityMin
				// decrease quantity
				? quantityCurrentVal - 1
				// else, stay at current quantity
				: quantityCurrentVal

		if (itemProductID == 4844103532587 && quantityNewVal < 50) {
			$('#giftcard-qty2').css('display', 'none');
			if (document.URL.includes("/cart")) {
				$('#giftcard-qty').css('display', 'none');
			}
		}
		// Control of 50 qty of GiftCard	
		if (itemProductID == 4844103532587 && quantityNewVal > 50) {
			$('#giftcard-qty2').css('display', 'inline-block');
			if (document.URL.includes("/cart")) {
				$('#giftcard-qty').css('display', 'inline-block');
			}
		}
		else {
			// update quantity text and value
			item.find('.item-quantity-current')
				.text(quantityNewVal).val(quantityNewVal);

			// trigger ajax update
			itemUpdate(item, quantityNewVal, null);

			// remove item if quantity is 0
			(quantityNewVal == 0)
				? item.remove() : '';
		}
		if (frgiSystem) {
		setTimeout(function(){
			$('#qty-plus').prop('disabled', false);
		$('#qty-minus').prop('disabled', false);
		  }, 2500);
		}
	});

	_document.on('click', '.item-remove', function (e) {
		e.preventDefault();

		let _this = $(this);
		let item = _this.closest('.item');

		loadingBarTrigger('start');

		// remove item div
		item.fadeOut()
			.delay(300).remove();

		// trigger ajax update
		itemUpdate(item, 0, null);
	});

	_document.on('click', '.item-edit', function () {
		let _this = $(this);
		let item = _this.closest('.item');
		let itemId = item.attr('data-item-id');
		let itemVariants = item.find('.item-info-variants');
		let itemQuantity = item.find('.item-info-quantity');

		if (itemQuantity.val() != itemQuantity.attr('data-select-original')) {
			loadingBarTrigger('start');

			itemUpdate(item, itemQuantity.val(), null);

			itemQuantity.attr('data-select-original', itemQuantity.val());

			// if variant didn't change, then adjust quantity
			if (itemVariants.val() == itemVariants.attr('data-select-original')) {
				item.find('.item-quantity').val(itemQuantity.val());
			}
		}

		if (itemVariants.val() != itemVariants.attr('data-select-original')) {
			loadingBarTrigger('start');

			// remove current variant ID
			itemUpdate(item, 0,
				// then add new variant, with co-responding quantities
				function () {
					itemAdd(itemVariants.val(), itemQuantity.val(),
						(!_this.closest('#slide-cart-content').length)
							? true : false
					);
				}
			);

			// update item ID and variant text selected variant
			item.attr('data-item-id', itemVariants.val());

			item.find('.item-info-variant-current').text(itemVariants.find('option:selected').text());

			itemVariants.attr('data-select-original', itemVariants.val());
		}

		_this.toggleText('Edit', 'Done');
		item.find('.item-action-reveal').toggleClass('active');
	});

	// Minicart actions
	minicartTrigger.click(function (e) {
		e.preventDefault();

		html.addClass('minicart_active');
	});

	minicartClose.click(function () {
		html.removeClass('minicart_active');
	});

	// Giftbox
	const giftbox = $('#cart-giftbox');
	const giftboxAdd = $('#giftbox-add');
	const noteRecipient = $('#giftbox-notes-recipient');
	const noteMessage = $('#giftbox-notes-message');
	const noteRecipientMsg = $('#giftbox-notes-recipient-msg');
	const noteMessageMsg = $('#giftbox-notes-message-msg');
	const giftNoteReveal = $('.gift-note-reveal');
	const selectGiftOptions = $('#select-gift-options')
	const removeGiftOptions = $('#remove-gift')

	//LocalStorage
	customerStorage = window.localStorage;

	itemGiftBoxExclude();

	updateGiftboxNote();

	cartControlGiftbox();

	if (document.URL.includes("/cart")) {
		$('.item-remove-mini').css('display', 'none');
	}

	if (removeGiftOptions) {
		removeGiftOptions.click(function() {
			$('.giftbox-selected').css('display','none')
			selectGiftOptions.text('SELECT GIFT OPTIONS')
			customerStorage.removeItem('radioGift');
			$('input[name="giftboxOption"]').prop('checked', false);
			$('#giftbox-notes-recipient-msg').val('');
			$('#giftbox-notes-message-msg').text('');
			$('#giftbox-notes-recipient').val('');
			$('#giftbox-notes-message').text('');
			customerStorage.removeItem('recipientMsg');
			customerStorage.removeItem('messageMsg');
			customerStorage.removeItem('recipientMsg');
			customerStorage.removeItem('messageMsg');
			jQuery.post('/cart/update.js', { updates: { 31272537948203: 0 } });
			if (document.URL.includes("/cart")) {
				cartReload(false, true);
			} else {
				$('#cart-giftbox').remove();
				$('.item').filter('[data-item-id="31272537948203"]').remove();
			}
			$('.giftbox-not-available').css('display', 'none');
		});
	}

	function cartControlGiftbox(){
		let radioBtn = getWithExpiry('radioGift')
		if (radioBtn) {
			selectGiftOptions.text('CHANGE GIFT OPTIONS')
			$('.giftbox-selected').css('display','block')
			if(radioBtn === 'msg') {
				$('#giftbox-selected-op').text($('#gift-radio-msg').data('type'))
				if (document.URL.includes("/cart")) {
					$('#gift-radio-msg').prop('checked',true)
					$('#giftbox-select').css('display','block')
					$('.giftbox-actions-msg').slideDown();
					$('.giftbox-edit-box').css('display', 'none');
					$('.giftbox-edit-msg').css('display', 'none');
					enteredText = $('#giftbox-notes-message-msg').val();
					replacedText = enteredText.replace(/§/g, "\n");
					$('#giftbox-notes-message-msg').val(replacedText);
					setWithExpiry('radioGift','box',3600000)
					selectGiftOptions.css('display', 'none')
					$('.giftbox-selected').css('display','none')
				}
			}
			else if(radioBtn === 'box') {
				$('#giftbox-selected-op').text($('#gift-radio-box').data('type'))
				if (document.URL.includes("/cart")) {
					$('#gift-radio-box').prop('checked',true)
					$('#giftbox-select').css('display','block')
					$('.giftbox-actions').slideDown();
					$('.giftbox-edit-box').css('display', 'none');
					$('.giftbox-edit-msg').css('display', 'none');
					enteredText = $('#giftbox-notes-message').val();
					replacedText = enteredText.replace(/§/g, "\n");
					$('#giftbox-notes-message').val(replacedText);
					setWithExpiry('radioGift','box',3600000)
					selectGiftOptions.css('display', 'none')
					$('.giftbox-selected').css('display','none')
				}
			}	
			
			selectGiftOptions.click(function (){
				let radioBtn =getWithExpiry('radioGift')
				$('.giftbox-selected').css('display','none')
				if(radioBtn === 'msg') {
					$('#giftbox-selected-op').text($('#gift-radio-msg').data('type'))
					$('#gift-radio-msg').prop('checked',true)
					$('#gift-radio-box').prop('checked',false)
					if (getWithExpiry('recipientMsg') != null || getWithExpiry('messageMsg') != null) {
						$('.giftbox-edit-msg').css('display', 'inline-block');
						$('.giftbox-edit-box').css('display', 'none');
					}
				}
				else if(radioBtn === 'box') {
					$('#giftbox-selected-op').text($('#gift-radio-box').data('type'))
					$('#gift-radio-msg').prop('checked',false)
					$('#gift-radio-box').prop('checked',true)
					if (getWithExpiry('recipient') != null || getWithExpiry('message') != null) {
						$('.giftbox-edit-msg').css('display', 'none');
						$('.giftbox-edit-box').css('display', 'inline-block');
					}
				}
				else{
					$('#gift-radio-msg').prop('checked',false)
					$('#gift-radio-box').prop('checked',false)
					$('.giftbox-edit-msg').css('display', 'none');
					$('.giftbox-edit-box').css('display', 'none');
				}
				$('#giftbox-select').slideToggle();
				selectGiftOptions.css('display','none')
			})
		}
		else{
			selectGiftOptions.click(function () {
				$('#giftbox-select').slideToggle();
				selectGiftOptions.css('display','none')
			});
		}
	}

	function updateGiftboxNote() {
		if (giftboxAdd.prop('checked') == true) {
			$('#giftbox-button').css('display', 'inline-block');
			if (document.URL.includes("/cart") && (getWithExpiry('recipient') == null || getWithExpirym('message') == null)) {
				$('.giftbox-notes').slideDown();
			}
		}
		else {
			$('#giftbox-button').css('display', 'none');
			$('#gift-note-added').css('display', 'none')
		}
		if (getWithExpiry('recipient') != null || getWithExpiry('message') != null) {
			$('#giftbox-notes-recipient').val(getWithExpiry('recipient'));
			$('#giftbox-notes-message').text(getWithExpiry('message'));
			initFields();
			if ($('#giftbox-add').prop('checked') == true) {
				$('#gift-note-added').css('display', 'inline-block');
				giftNoteReveal.css('display', 'inline-block');
				giftNoteReveal.text('EDIT')
				giftNoteReveal.css('border-bottom', '1px solid black');
				giftNoteReveal.css('padding-bottom', '2px');
			}
		}
		if (getWithExpiry('recipientMsg') != null || getWithExpiry('messageMsg') != null) {
			$('#giftbox-notes-recipient-msg').val(getWithExpiry('recipientMsg'));
			$('#giftbox-notes-message-msg').text(getWithExpiry('messageMsg'));
			$('#giftbox-notes-recipient').val(getWithExpiry('recipientMsg'));
			$('#giftbox-notes-message').text(getWithExpiry('messageMsg'));
			initFields();
			if($('#gift-radio-msg').prop("checked", true)) $('.giftbox-edit-msg').css('display', 'inline-block');
		}

	}

	async function getJsonCollection(collectionName) {
		const response = await fetch('/collections/' + collectionName + '?view=json');
		const json = await response.json();
		return json;
	}


	giftboxAdd.click(function () {
		if ($(this).prop('checked') == true) {
			if (document.URL.includes("/cart")) {
				itemAdd('31272537948203', 1, false, true);
				enteredText = $('#giftbox-notes-message').val();
				replacedText = enteredText.replace(/§/g, "\n");
				$('#giftbox-notes-message').val(replacedText);
			} else {
				itemAdd('31272537948203', 1, true, false);
				enteredText = $('#giftbox-notes-message').val();
				replacedText = enteredText.replace(/§/g, "\n");
				$('#giftbox-notes-message').val(replacedText);
				cartReload(true, false);
			}
		} else {
			$('#giftbox-button').css('display', 'none');
			$('#giftbox-button').css('border-bottom', 'unset');
			$('#gift-note-added').css('display', 'none');
			giftNoteReveal.css('display', 'none');
			$('.giftbox-not-available').css('display', 'none');
			$('.giftbox-not-available2').css('display', 'none');
			jQuery.post('/cart/update.js', { updates: { 31272537948203: 0 } });
			if (document.URL.includes("/cart")) {
				cartReload(false, true);
			} else {
				$('#cart-giftbox').remove();
				$('.item').filter('[data-item-id="31272537948203"]').remove();

			}
			cartTotalUpdate();
		}
	});


	$('.giftbox-notes-save').click(function () {
		$('#gift-radio-box').prop('checked',true)
		if (noteRecipient.val() || noteMessage.val()) {
			setWithExpiry('recipient', noteRecipient.val(),3600000);
			setWithExpiry('message', noteMessage.val(),3600000);
			//$('#giftbox-notes-recipient-msg').val(noteRecipient.val());
			//$('#giftbox-notes-message-msg').val(noteMessage.val());
		}
		$('#giftbox-notes-recipient-msg').val('');
		$('#giftbox-notes-message-msg').val('');
		$('#gift-note-added').css('display', 'inline-block');
		giftNoteReveal.css('display', 'inline-block');
		giftNoteReveal.text('EDIT')
		giftNoteReveal.css('border-bottom', '1px solid black');
		giftNoteReveal.css('padding-bottom', '2px');
		$('.giftbox-edit-box').css('display', 'inline-block');
		if($('.giftbox-actions').is(':visible')) {
			selectGiftOptions.text('CHANGE GIFT OPTIONS')
			selectGiftOptions.css('display', 'inline-block');
			$('#giftbox-select').css('display', 'none');
			$('.giftbox-selected').css('display', 'block');
		}
	});

	$('.giftbox-notes-save-msg').click(function () {
		$('#gift-radio-msg').prop('checked',true)
		if (noteRecipientMsg.val() || noteMessageMsg.val()) {
			setWithExpiry('recipientMsg', noteRecipientMsg.val(),3600000);
			setWithExpiry('messageMsg', noteMessageMsg.val(),3600000);
			//$('#giftbox-notes-recipient').val(noteRecipientMsg.val());
			//$('#giftbox-notes-message').val(noteMessageMsg.val());
		}
		$('#giftbox-notes-recipient').val('');
		$('#giftbox-notes-message').val('');
		$('#gift-note-added').css('display', 'inline-block');
		$('.giftbox-edit-msg').css('display', 'inline-block');
		let _this = $(this);

		$('.giftbox-notes-msg').slideToggle();

		if (noteRecipientMsg.val() || noteMessageMsg.val()) {
			$('.giftbox-edit-msg').css('display', 'inline-block');
		}

		if($('.giftbox-actions-msg').is(':visible')) {
			selectGiftOptions.text('CHANGE GIFT OPTIONS')
			selectGiftOptions.css('display', 'inline-block');
			$('#giftbox-select').css('display', 'none');
			$('.giftbox-selected').css('display', 'block');
		}

	});

	$('#giftbox-notes-message-msg').keypress(function (e) {
		let charlimit = 42; // char limits per line
		let lines = $(this).val().split('\n');
		var maxLines = 6; // max line breaks textarea

		$('#char-num-2').css('display', 'inline-block');
		enteredText = $(this).val();
		numberOfLineBreaks = ((enteredText.match(/\n/g) || []).length) + 1;
		$("#char-num-2").text($(this).val().length + '/250 OF ' + numberOfLineBreaks + '/6 LINES');

		for (let i = 0; i < lines.length; i++) {
			if (lines[i].length <= charlimit) continue;
			let j = 0; space = charlimit;
			while (j++ <= charlimit) {
				if (lines[i].charAt(j) === ' ') space = j;
			}
			lines[i + 1] = lines[i].substring(space + 1) + (lines[i + 1] || "");
			lines[i] = lines[i].substring(0, space);
		}
		if (lines.length <= 6) {
			$(this).val(lines.slice(0, 10).join('\n'));
		}
		else {
			e.preventDefault();
			return false;
		}
		if ($(this).val().length == 0) $('#char-num-2').css('display', 'none');
	});

	$('#giftbox-notes-message').keypress(function (e) {
		let charlimit = 42; // char limits per line
		let lines = $(this).val().split('\n');
		var maxLines = 6; // max line breaks textarea

		$('#char-num').css('display', 'inline-block');
		enteredText = $(this).val();
		numberOfLineBreaks = ((enteredText.match(/\n/g) || []).length) + 1;
		$("#char-num").text($(this).val().length + '/250 OF ' + numberOfLineBreaks + '/6 LINES');

		for (let i = 0; i < lines.length; i++) {
			if (lines[i].length <= charlimit) continue;
			let j = 0; space = charlimit;
			while (j++ <= charlimit) {
				if (lines[i].charAt(j) === ' ') space = j;
			}
			lines[i + 1] = lines[i].substring(space + 1) + (lines[i + 1] || "");
			lines[i] = lines[i].substring(0, space);
		}
		if (lines.length <= 6) {
			$(this).val(lines.slice(0, 10).join('\n'));
		}
		else {
			e.preventDefault();
			return false;
		}
		if ($(this).val().length == 0) $('#char-num').css('display', 'none');
	});

	$('#giftbox-notes-message, #giftbox-notes-message').keydown(function (e) {
		var maxLines = 6; // max line breaks textarea
		newLines = $(this).val().split("\n").length;
		if (e.keyCode == 13 && newLines >= maxLines) {
			return false;
		}
	});

	//NEWGIFTBOX
	$('input:radio[name="giftboxOption"]').change(
		function(){
			$('input:radio[name="giftboxOption"]').prop('disabled',true);
			if ($(this).is(':checked') && $(this).val() == 'msg') {
				if (getWithExpiry('recipient') ||getWithExpiry('message')) {
					$('#giftbox-notes-recipient-msg').val(getWithExpiry('recipient'));
					$('#giftbox-notes-message-msg').val(getWithExpiry('message'));
					$('#giftbox-notes-recipient').val('');
					$('#giftbox-notes-message').val('');
				}
				setWithExpiry('radioGift','msg',3600000)
				$('#giftbox-selected-op').text($('#gift-radio-msg').data('type'))
				$('.giftbox-actions-msg').slideDown();
				$('.giftbox-actions').slideUp();
				$('.giftbox-edit-msg').css('display', 'none');
				$('.giftbox-edit-box').css('display', 'none');
				$('#giftbox-button').css('display', 'none');
				$('#giftbox-button').css('border-bottom', 'unset');
				$('#gift-note-added').css('display', 'none');
				giftNoteReveal.css('display', 'none');
				$('.giftbox-not-available').css('display', 'none');
				$('.giftbox-not-available2').css('display', 'none');
				jQuery.post('/cart/update.js', { updates: { 31272537948203: 0 } });
				if (document.URL.includes("/cart")) {
					cartReload(false, true);
				} else {
					$('#cart-giftbox').remove();
					$('.item').filter('[data-item-id="31272537948203"]').remove();

				}
				cartTotalUpdate();
				$('input:radio[name="giftboxOption"]').prop('disabled',false);
			}
			else {
				$('#giftbox-selected-op').text($('#gift-radio-box').data('type'))
				if (getWithExpiry('recipientMsg') || getWithExpiry('messageMsg')) {
					$('#giftbox-notes-recipient').val(getWithExpiry('recipientMsg'));
					$('#giftbox-notes-message').val(getWithExpiry('messageMsg'));
					$('#giftbox-notes-recipient-msg').val('');
					$('#giftbox-notes-message-msg').val('');
				}
				if (document.URL.includes("/cart")) {
					$('#gift-radio-box').prop('checked',true)
					$('.giftbox-actions-msg').slideUp();
					$('.giftbox-actions').slideDown();
					$('.giftbox-edit-box').css('display', 'none');
					$('.giftbox-edit-msg').css('display', 'none');
					enteredText = $('#giftbox-notes-message').val();
					replacedText = enteredText.replace(/§/g, "\n");
					$('#giftbox-notes-message').val(replacedText);
					setWithExpiry('radioGift','box',3600000)
					$('input:radio[name="giftboxOption"]').prop('disabled',false);
					itemAdd('31272537948203', 1, false, true);
				} else {
					itemAdd('31272537948203', 1, true, false);
					enteredText = $('#giftbox-notes-message').val();
					replacedText = enteredText.replace(/§/g, "\n");
					$('#giftbox-notes-message').val(replacedText);
					cartReload(true, false);
					setTimeout(function () {
						//$('.giftbox-actions-msg').slideUp();
						$('#gift-radio-box').prop('checked',true)
						$('.giftbox-actions-msg').slideUp();
						$('.giftbox-actions').slideDown();
						$('.giftbox-edit-box').css('display', 'none');
						$('.giftbox-edit-msg').css('display', 'none');
						setWithExpiry('radioGift','box',3600000)
						$('input:radio[name="giftboxOption"]').prop('disabled',false);
					}, 2500);
				}
			}
		});

		$('.giftbox-edit-msg').click( function (){
			$('.giftbox-actions-msg').slideToggle();
			if($('.giftbox-actions-msg').is(':visible')) {
				$('.giftbox-edit-msg').css('display', 'none');
			}
			else{
				$('.giftbox-edit-msg').css('display', 'inline-block');
			}
		})

		$('.giftbox-edit-box').click( function (e){
			$('.giftbox-actions').slideToggle();
			e.stopPropagation();
			if($('.giftbox-actions').is(':visible')) {
				$('.giftbox-edit-box').css('display', 'none');
			}
			else{
				$('.giftbox-edit-box').css('display', 'inline-block');
			} 
		})

	// revert replace of line break to show line break at textarea
	/* $('.gift-note-reveal').click(function () {
		enteredText = $('#giftbox-notes-message').val();
		replacedText = enteredText.replace(/§/g, "\n");
		$('#giftbox-notes-message').val(replacedText);
	}); */

	$('.gift-note-reveal, .giftbox-notes-save').click(function () {
		let _this = $(this);

		$('.giftbox-notes').slideToggle();

		if (noteRecipient.val() || noteMessage.val()) {
			$('#gift-note-added').css('display', 'inline-block');
			giftNoteReveal.text('EDIT')
			giftNoteReveal.css('border-bottom', '1px solid black');
			giftNoteReveal.css('padding-bottom', '2px');
		}
	});

/* 	$('.giftbox-notes-save-msg').click(function () {
		let _this = $(this);

		$('.giftbox-notes-msg').slideToggle();

		if (noteRecipientMsg.val() || noteMessageMsg.val()) {
			$('.giftbox-edit-msg').css('display', 'inline-block');
		}
	}); */

	$('.gift-note-clear').click(function () {
		noteRecipient.val('');
		noteMessage.val('');
		$('#gift-note-added').css('display', 'none');
		$('#giftbox-button').css('display', 'none');
		//giftNoteReveal.text('Add a Note -');
		customerStorage.removeItem('recipient');
		customerStorage.removeItem('message');
		$('#giftbox-button').css('border-bottom', 'unset');
	});

	$.merge(noteRecipient, noteMessage).on('blur', function () {
		(noteRecipient.val() || noteMessage.val())
			? giftboxAdd.prop('checked', true).change()
			: '';
	});

	_window.click(function (e) {
		let target = $(e.target);

		if (!target.is('.gift-note-reveal') &&
			!target.closest('.gift-note-reveal').length &&
			!target.is('.giftbox-notes') &&
			!target.closest('.giftbox-notes').length) {

			$('.giftbox-notes').slideUp();

			if (noteRecipient.val() || noteMessage.val()) {
				//$('#gift-note-added').css('display', 'inline-block');
				giftNoteReveal.text('EDIT')
				giftNoteReveal.css('border-bottom', '1px solid black');
				giftNoteReveal.css('padding-bottom', '2px');
			}
			else {
				giftNoteReveal.text('Add a Note +');
			}

		}
	});

	if (screenIsTablet) {
		$('#cart-summary').clone()
			.insertAfter('#cart-header .t-h-5').find('#summary-additional-buttons, .t-h-5').remove();
	}
}

const initBlogIndex = () => {
	const articlesList = $('#articles-list');

	siteReadyTrigger(function () {
		articlesList.isotope({
			itemSelector: '.article',
			layoutMode: 'masonry',
			isOriginLeft: false,
			masonry: {
				columnWidth: 1
			}
		});
	}, 100);
}

const initBlogSingle = () => {
	const content = $('#article-content');
	const stickyHeader = $('#article-sticky-header');
	const blogSingleScroll = () => {
		(scrollTop > windowHeight / 2)
			? stickyHeader.addClass('active')
			: stickyHeader.removeClass('active');
	}

	siteReadyTrigger(blogSingleScroll);
	_window.scroll(blogSingleScroll);

	content.find('p:has(img)').each(function () {
		$(this).children().unwrap();
	});

	$('.article-share').each(function () {
		let share = $(this);

		share.width(share.width())
			.attr('data-original-width', share.width());

		share.find('.article-share-trigger').click(function () {
			share.toggleClass('share-active');

			(share.hasClass('share-active'))
				? share.width(share.find('ul').width() + 30)
				: share.width(share.attr('data-original-width'));
		});
	});
}

const initCompAppointmentEmbed = () => {
	$('[data-appointment-embed]').click(function (e) {
		e.preventDefault();

		if ($('#appointment-embed').length) {
			$('#appointment-embed-iframe').html(`<iframe src="${$(this).attr('data-appointment-embed')}?embed_domain=www.lunya.co&embed_type=PopupText"></iframe>`);
		} else {
			body.append(`
				<div 
					id="appointment-embed"
					class="g-flex g-vertical user-select-disable">
					<div class="appointment-embed-overlay"></div>
					<div 
						id="appointment-embed-iframe" 
						class="width">
						<iframe src="${$(this).attr('data-appointment-embed')}?embed_domain=www.lunya.co&embed_type=PopupText"></iframe>
					</div>
					<button 
						id="appointment-embed-close" 
						class="comp-close" 
						aria-label="Close lightbox">
						<svg class="svg-close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.85 14.85"><g><path d="M6.72 7.42L0 14.14l.71.71 6.71-6.72 6.72 6.72.71-.71-6.72-6.72L14.85.71 14.14 0 7.42 6.72.71 0 0 .71z" fill="currentColor" fill-rule="evenodd"/></g></svg></button>
				</div>
			`);
		}

		setTimeout(function () {
			html.addClass('appointment_embed_active');
		}, 10);
	});

	_document.on('click', '#appointment-embed-close, #appointment-embed-overlay',
		function () {
			html.removeClass('appointment_embed_active');
		});
}

const initLocationsSingle = () => {
	const stickyHeader = $('#locations-sticky-header');
	const locationsSingleScroll = () => {
		(scrollTop > windowHeight / 2)
			? stickyHeader.addClass('active')
			: stickyHeader.removeClass('active');
	}

	siteReadyTrigger(locationsSingleScroll);
	_window.scroll(locationsSingleScroll);
}

const initCareers = () => {
	$('.position-details-trigger').click(function () {
		let _this = $(this);

		_this.siblings('.position-details').slideToggle();
		_this.toggleText('More Details', 'Less Details');
	});
}

const initCx = () => {
	// content page selection
	const aside = $('#cx-content-aside');
	const content = $('#cx-content');

	$(`#cx-content-aside a, 
		[href*="#faq"],
		[href*="#contact"]`).click(function (e) {
		e.preventDefault();

		let _this = $(this);
		let contactActive = $(`[data-cx-tab="${_this.attr('href').replace('#', '').split('-')[0]}"]`);

		// assign active states
		(_this.closest('li').length)
			? _this.closest('li').addClass('active')
				.siblings().removeClass('active')
			: $('#cx-content-aside li:first-of-type').addClass('active')
				.siblings().removeClass('active');

		contactActive.addClass('active')
			.siblings().removeClass('active');

		// adjust content height
		content.css({
			'height': content.height(),
			'transition': 'height 0.6s'
		});

		setTimeout(function () {
			content.height(contactActive.height());
		}, 100);

		setTimeout(function () {
			content.css({
				'height': 'auto',
				'transition': '0s'
			});
		}, 601);

		// scroll to position
		scrollTo(_this.attr('href'));

		// update window hash
		history.pushState(null, null, _this.attr('href'));
	});

	if (window.location.hash &&
		$(`[data-cx-tab="${window.location.hash.replace('#', '')}"]`).length) {
		aside.find(`a[href="#${window.location.hash.replace('#', '')}"]`).click();
	}

	// faq search
	const faqSearch = $('#faq-search');
	const faq = $('.faq');

	faqSearch.on('keyup change', function () {
		let searchQuery = formatHandleize(faqSearch.val());

		faq.hide();

		if (searchQuery) {
			html.addClass('faq_search_active');

			faq.each(function () {
				let _this = $(this);

				(formatHandleize(_this.text()).includes(searchQuery))
					? _this.show()
					: '';
			});
		} else {
			html.removeClass('faq_search_active');
			faq.show();
		}
	});

	// contact form
	let contactForm = $('#cx-contact-form form');

	const contactFormSuccess = () => {
		contactForm.fadeOut();

		setTimeout(function () {
			contactForm.parent().append(`
				<div 
					id="cx-contact-form-success"
					class="form-success">
				${contactForm.attr('data-success-message')}</div>
			`).fadeIn();
		}, 300);
	}

	contactForm.submit(function (e) {
		e.preventDefault();

		$.ajax({
			type: 'POST',
			url: contactForm.attr('action'),
			dataType: 'json',
			cache: false,
			data: contactForm.serialize(),
			beforeSend: function () {
				loadingBarTrigger('start');
			},
			error: function (error) {
				console.error(error);
			},
			success: function (response) {
				contactFormSuccess();
				console.log(response);
			}
		}).always(function () {
			loadingBarTrigger('done');
		});
	});

	if (window.location.href.indexOf('?contact_posted=true') != -1) {
		$('[href="#contact"]').click();
		contactFormSuccess();
	}
}

const initFabricCare = () => {
	$('#fabric-care-slider .slide-content-b a').each(function () {
		let _this = $(this);

		_this.attr('href', `#fabric-care-${formatHandleize(_this.attr('title'))}`);
	});

	if (screenIsTablet) {
		$('.block-content p').each(function () {
			let _this = $(this);

			_this.wrap('<div class="toggle"></div>')
				.find('strong').addClass('toggle-label')
				.append('<div class="toggle-button"></div>')
				.remove().clone().prependTo(_this.parent('.toggle'))
				.siblings('p').addClass('toggle-content');
		});
	}
}

const initValentinesDay = () => {
	let appDomain = 'https://makeyourselfathome.lunya.co';
	let imgAssetUrl = `${appDomain}/assets/`;
	let stateContent = $('#valentines-content');
	let stateLetter = $('[data-valentines-state="Letter"]');
	let stateSubmission = $('[data-valentines-state="Submission"]');
	let stateReferral = $('[data-valentines-state="Referral"]');
	let stateSuccess = $('[data-valentines-state="Success"]');

	siteReadyTrigger(function () {
		stateContent.height(stateContent.height());
	});

	let changeState = (state) => {
		state.addClass('active')
			.siblings().removeClass('active');

		stateContent.height(state.innerHeight());

		scrollTo('#valentines-content');
	}

	stateLetter.find('input[type="text"]').on('keyup', function () {
		let _this = $(this);
		let val = _this.val();

		_this.width((val.length + 2) * 11);

		(val)
			? _this.addClass('has_value')
			: _this.removeClass('has_value');
	});

	formData = new FormData();

	stateLetter.find('form').submit(function (e) {
		e.preventDefault();

		// form submit init
		loadingBarTrigger('start');
		stateLetter.find('input[type="submit"]').css('opacity', 0)
			.siblings('hr').css('opacity', 0);

		// turn letter into canvas
		window.scrollTo(0, 0);

		html2canvas(document.querySelector('#valentines-letter'), {
			imageTimeout: 8000,
			useCORS: true,
		}).then(canvas => {
			let imgData = canvas.toDataURL('image/png');

			// convert canvas into base64image
			formData.append('base64Image', imgData);

			// switch to next screen
			loadingBarTrigger('move');
			changeState(stateSubmission);

			// upload converted png image
			$.ajax({
				'url': `${appDomain}/home/uploadImage`,
				'method': 'POST',
				'processData': false,
				'mimeType': 'multipart/form-data',
				'contentType': false,
				'data': formData,
				'async': false,
			}).done(function (res) {
				// append uploaded image url into form
				stateLetter.find('[name="img_url"]').val(res);

			}).always(function () {
				loadingBarTrigger('done');
				changeState(stateSubmission);
			});
		});
	});

	const formSubmission = (form, formNext, formSubmits) => {
		// form submission init
		formValidated = true;
		loadingBarTrigger('start');
		form.find('input[type="submit"]').prop('disabled', true);

		// validations
		form.find('input').each(function () {
			let input = $(this);

			if (!input.val() ||
				(input.attr('type') == 'email') && !validateEmail(input.val())) {
				input.closest('.field').addClass('error');
				formValidated = false;
				loadingBarTrigger('done');
				form.find('input[type="submit"]')
					.prop('disabled', false);
			} else {
				input.closest('.field').removeClass('error');
			}
		});

		// trigger submission
		if (formValidated == true) {
			let formData = new FormData();

			// loop through each form to construct data
			for (let i = 0; i < formSubmits.length; i++) {
				$.each(formSubmits[i].find('form').serializeArray(),
					function (key, input) {
						formData.append(input.name, input.value);
					});
			}

			// submit form data
			$.ajax({
				type: 'POST',
				processData: false,
				contentType: false,
				url: `${appDomain}${form.attr('action')}`,
				data: formData,
			}).done(function (data) {
				var res = $.parseJSON(data);
				loadingBarTrigger('done');

				if (res.error == true &&
					res.msg == 'User already exists in this week') {
					$('.form-error').slideDown();
					form.find('input[type="submit"]')
						.prop('disabled', false);
				} else {
					$('.form-error').slideUp();
					form.find('input[type="submit"]')
						.prop('disabled', false);
					changeState(formNext);
				}


			}).fail(function (error) {
				console.error(error)
			});
		}
	}

	stateSubmission.find('form').submit(function (e) {
		e.preventDefault();

		formSubmission($(this), stateReferral, [stateLetter, stateSubmission]);
	});


	stateReferral.find('form').submit(function (e) {
		e.preventDefault();

		formSubmission($(this), stateSuccess, [stateLetter, stateSubmission, stateReferral]);
	});

	$('.comp-navigation-sticky').clone().insertAfter('#influencers-header');
}

const initAccounts = () => {
	// password reset
	const gateWrapper = $('#account-gate-wrapper');
	const gateContent = $('#account-gate');
	const resetPasswordTrigger = $('#reset-password-trigger');
	const resetPasswordCancel = $('#reset-password-cancel');
	const resetPasswordField = $('#account-recover-email');

	resetPasswordTrigger.click(function (e) {
		e.preventDefault();

		html.addClass('reset_form_active');
		history.pushState(null, null, '#recover');

		resetPasswordField.focus();

		gateWrapper.height($('#account-reset').outerHeight(true));
	});

	resetPasswordCancel.click(function (e) {
		e.preventDefault();

		html.removeClass('reset_form_active');
		history.pushState(null, null, ' ');

		gateWrapper.height(gateContent.outerHeight(true));
	});

	(window.location.hash == '#recover')
		? resetPasswordTrigger.trigger('click') : '';

	gateWrapper.height(gateContent.outerHeight(true));

	// address management
	const addressAddTrigger = $('#address-add-trigger');

	addressAddTrigger.click(function () {
		html.addClass('address_pop_active');

		$('#address-add').show();
	});

	// responsive selector
	if (screenisCompact) {
		let dashboardAsideUl = $('#dashboard-aside ul');

		dashboardAsideUl.find('li').each(function () {
			let _this = $(this);

			_this.replaceWith($(`<option 
				data-url="${_this.find('a').attr('href')}" 
				${(_this.hasClass('active')) ? 'selected' : ''}>
				${this.innerHTML}</option>`));
		});

		dashboardAsideUl.replaceWith($(`<select id="dashboard-aside-select">${dashboardAsideUl.html()}</select>`));

		_document.on('change', '#dashboard-aside-select', function () {
			window.location.href = $('#dashboard-aside-select').find('option:selected').attr('data-url');
		});
	}
}

const initFields = () => {
	let inputs = $(`.field input[type="text"],
		.field input[type="email"], 
		.field input[type="tel"],
		.field input[type="url"],
		.field input[type="password"],
		.field textarea`);
	let select = $('.field select');

	inputs.on('init blur', function () {
		let _this = $(this);

		(_this.val().length > 0)
			? _this.closest('.field').addClass('has_value')
			: _this.closest('.field').removeClass('has_value');
	});

	siteReadyTrigger(function () {
		inputs.trigger('init');
	});

	select.on('change', function () {
		let _this = $(this);

		_this.closest('.field').addClass('has_value');
	});
}

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const initCompNavigationSticky = () => {
	const section = $('[data-navigation-section]');
	const navigationScroll = () => {
		let scrollTopOffset = scrollTop + scrollOffset;

		if(isMobile) {
			(scrollTopOffset > $(section[0]).attr('data-navigation-top') &&
			scrollTopOffset < parseInt($(section[section.length - 1]).attr('data-navigation-top')) + (windowHeight *4))
			? html.addClass('sticky_navigation_active')
			: html.removeClass('sticky_navigation_active');
		}
		else {
		(scrollTopOffset > $(section[0]).attr('data-navigation-top') &&
			scrollTopOffset < parseInt($(section[section.length - 1]).attr('data-navigation-top')) + (windowHeight *3))
			? html.addClass('sticky_navigation_active')
			: html.removeClass('sticky_navigation_active');
		}

		// get all anchor with top offset
		section.each(function (i) {
			let _this = $(this);
			let _thisTop = parseInt(_this.attr('data-navigation-top'));
			let _thisNextTop = $(section[i + 1]).length
				? parseInt($(section[i + 1]).attr('data-navigation-top'))
				: Infinity

			if(!isMobile) {
				if(i > 2){
					scrollTopOffset =  scrollTopOffset - 200
				}
			}
			else {
				if(i > 2 && i <= 5){
					scrollTopOffset =  scrollTopOffset - 300
				}
				else if (i >= 6) {
					scrollTopOffset =  scrollTopOffset - 400
				}
			}

			if (scrollTopOffset > _thisTop &&
				scrollTopOffset < _thisNextTop) {
				$(`.comp-navigation-sticky a[href^="#${_this.attr('id')}"]`)
					.parent().addClass('active')
					.siblings().removeClass('active');
			}
		});
	}

	// creat and prepend navigation HTML
	navigationHtml = '';
	section.each(function () {
		let _this = $(this);

		navigationHtml += `<li>
			<a href="#${_this.attr('id')}">${_this.attr('data-navigation-section')}</a>
		</li>`
	});

	body.append(`<div class="comp-navigation-sticky">
		<ul class="t-link user-select-disable">${navigationHtml}</ul>
	</div>`);

	// register navigation click action
	_document.on('click', '.comp-navigation-sticky a', function (e) {
		e.preventDefault();

		scrollTo($(this).attr('href'));
	});

	// assign scroll top position to each navigation collection
	section.each(function () {
		let _this = $(this);

		siteReadyTrigger(function () {
			_this.attr('data-navigation-top', Math.floor(_this.offset().top));
			navigationScroll();
		});
	});

	// run scroll functions
	_window.scroll(navigationScroll);
}

const initCompNavigationStickySust = () => {
	const section = $('[data-navigation-section]');
	const navigationScroll = () => {
		let scrollTopOffset = scrollTop + scrollOffset;

		if(isMobile) {
			(scrollTopOffset > $(section[0]).attr('data-navigation-top') &&
			scrollTopOffset < parseInt($(section[section.length - 1]).attr('data-navigation-top')) + (windowHeight *3))
			? html.addClass('sticky_navigation_active')
			: html.removeClass('sticky_navigation_active');
		}
		else {
		(scrollTopOffset > $(section[0]).attr('data-navigation-top') &&
			scrollTopOffset < parseInt($(section[section.length - 1]).attr('data-navigation-top')) + (windowHeight *2))
			? html.addClass('sticky_navigation_active')
			: html.removeClass('sticky_navigation_active');
		}


		// get all anchor with top offset
		section.each(function (i) {
			let _this = $(this);
			let _thisTop = parseInt(_this.attr('data-navigation-top'));
			let _thisNextTop = $(section[i + 1]).length
				? parseInt($(section[i + 1]).attr('data-navigation-top'))
				: Infinity

			if(!isMobile) {
				if(i > 2){
					scrollTopOffset =  scrollTopOffset - 200
				}
			}
			else {
				if(i > 2 && i <= 5){
					scrollTopOffset =  scrollTopOffset - 300
				}
				else if (i >= 6) {
					scrollTopOffset =  scrollTopOffset - 400
				}
			}

			if (scrollTopOffset > _thisTop &&
				scrollTopOffset < _thisNextTop) {
				$(`.comp-navigation-sticky-v2 a[href^="#${_this.attr('id')}"]`)
					.parent().addClass('active')
					.siblings().removeClass('active');
			}
		});
	}

	// creat and prepend navigation HTML
	navigationHtml = '';
	section.each(function () {
		let _this = $(this);

		navigationHtml += `<li>
			<a href="#${_this.attr('id')}">${_this.attr('data-navigation-section')}</a>
		</li>`
	});

	body.append(`<div class="comp-navigation-sticky-v2">
		<ul class="t-link user-select-disable">${navigationHtml}</ul>
	</div>`);

	// register navigation click action
	_document.on('click', '.comp-navigation-sticky-v2 a', function (e) {
		e.preventDefault();

		scrollTo($(this).attr('href'));
	});

	// assign scroll top position to each navigation collection
	section.each(function () {
		let _this = $(this);

		siteReadyTrigger(function () {
			_this.attr('data-navigation-top', Math.floor(_this.offset().top));
			navigationScroll();
		});
	});

	// run scroll functions
	_window.scroll(navigationScroll);
}

const md5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}


const initCompNewsletter = () => {
	const submitSuccess = (form) => {
		form.addClass('success')
			.find('h2').text('Thanks for subscribing!');

		setTimeout(function () {
			form.find('h2').after(`<p class="newsletter-success">${(form.closest('#newsletter-popup').length)
				? 'We can’t wait to connect.<br>Check your email for promo your code.'
				: 'You’re now subscribed to our newsletter. You should receive a confirmation email shortly.'
				}</p>`).fadeIn();
		}, 300);
	}

	const retentionScienceSubmission = (email, properties) => {
		window._rsq = window._rsq || [];
		window._rsq.push(['_setSiteId', '635']); // Your unique ReSci ID
		window._rsq.push(['_enableOnsite']);
		window._rsq.push(['_setUserEmail', email]);
		window._rsq.push(['_setUserProperties', properties]);
		window._rsq.push(['_setAction', 'email_entered']);
		window._rsq.push(['_track']);

		(function() {
			var rScix = document.createElement('script');
			rScix.type = 'text/javascript';
			rScix.async = true;
			rScix.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'd1stxfv94hrhia.cloudfront.net/waves/v3/w.js';
			(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(rScix);
		})();
	}

	$('.comp-newsletter').submit(function (e) {
		let _this = $(this);
		let tags = _this.find('[name="contact[tags]"]:checked').val() || null;
		let newsletterEmail = _this.find('input[type="email"]');

		if (!newsletterEmail.val() ||
			!validateEmail(newsletterEmail.val())) {
			e.preventDefault();

			_this.find('.newsletter-email-field, .field')
				.addClass('error');
		} else {
			let gender = (tags) ? tags.split(',')[tags.split(',').length - 1] : null;
			let genderFormatted = (gender == 'man')
				? 'm' : (gender == 'woman')
					? 'f' : null;

					//alert(md5((newsletterEmail.val().toLowerCase())))
			retentionScienceSubmission(newsletterEmail.val(), {
				'record_id': md5((newsletterEmail.val().toLowerCase())),
				'email': newsletterEmail.val(),
				'gender': genderFormatted,
				'registration_source': 'shopify'
			});

			$.ajax({
				type: 'POST',
				async: true,
				url: _this.attr('action'),
				data: _this.serialize(),
				beforeSend: function () {
					loadingBarTrigger('start');
				},
				error: function (error) {
					console.error(error);

					localStorage.setItem('luNewsletterSubmittedLocation',
						_this.find('[name="location"]').val());

					if (error.status != 429) {
						e.preventDefault();
					}
				},
				success: function (response) {
					e.preventDefault();
					submitSuccess(_this);
				}
			}).always(function () {
				loadingBarTrigger('done');
			});
		}
	});

	let submittedLocation = localStorage.getItem('luNewsletterSubmittedLocation');

	if ((window.location.href.indexOf('?customer_posted=true') != -1 ||
		window.location.href.indexOf('?contact') != -1) &&
		submittedLocation) {
		localStorage.removeItem('luNewsletterSubmittedLocation');

		if (submittedLocation == 'Footer Newsletter') {
			scrollTo('#footer-newsletter');
			submitSuccess($('#footer-newsletter .comp-newsletter'));

		} else if (submittedLocation == 'Footer Connect') {
			scrollTo('#footer');
			submitSuccess($('#footer-connect .comp-newsletter'))

		} else if (submittedLocation == 'Popup') {
			html.addClass('newsletter_popup_active');
			submitSuccess($('#newsletter-popup .comp-newsletter'));
		}
	}
}

const initCompSlider = () => {
	$('.comp-slider').each(function () {
		let slider = $(this);
		let sliderContent = slider.find('.slider-content');

		slider.imagesLoaded(function () {
			if (sliderContent.width() < html.find('.width').width()) {
				slider.addClass('slider-disabled');
				slider.find('.slide-spacer').remove();
			} else {
				if (!slider[0].hasAttribute('data-slider-wraparound') &&
					!screenIsMobile) {
					sliderContent.append('<div class="slide-spacer"></div>')
						.prepend('<div class="slide-spacer"></div>');
				}
				sliderContent.flickity({
					cellSelector: '[class^="slide-"]',
					cellAlign: slider[0].hasAttribute('data-slider-cellalign')
						? slider.attr('data-slider-cellalign')
						: slider[0].hasAttribute('data-slider-wraparound')
							? 'center'
							: (screenIsMobile)
								? 'center' : 'left',
					wrapAround: slider[0].hasAttribute('data-slider-wraparound')
						? true : (screenIsMobile)
							? true : false,
					prevNextButtons: slider[0].hasAttribute('data-slider-arrows')
						? true : false,
					pageDots: slider[0].hasAttribute('data-slider-dots')
						? true : false,
					draggable: slider[0].hasAttribute('data-slider-draggable')
						? true : (screenIsMobile)
							? true : false,
					freeScroll: (screenIsMobile)
						? true : false,
					contain: true,
					imagesLoaded: true,
					groupCells: true,
					accessibility: true
				});
			}
		});
	});
}

const initCompSliderTestimonial = () => {
	$('.comp-slider-testimonial').each(function () {
		let testimonial = $(this);
		let testimonialSlider = testimonial.find('.slider-testimonial-content');

		testimonial.imagesLoaded(function () {
			testimonialSlider.flickity({
				cellAlign: 'center',
				wrapAround: true,
				prevNextButtons: false,
				pageDots: (testimonial.find('.testimonial').length > 1) ? true : false
			}).on('staticClick.flickity', function (e, pointer, el, i) {
				if (typeof i == 'number') {
					testimonialSlider.flickity('select', i);
				}
			});
		});
	});
}

const initCompSliderTopbar = () => {

	$('.comp-slider-topbar').each(function () {
		let topbar = $(this);
		let topbarSlider = topbar.find('.slider-topbar-content');

		topbar.imagesLoaded(function () {
			topbarSlider.flickity({
				cellAlign: 'center',
				fade: true,
				pauseAutoPlayOnHover: false,
				prevNextButtons: false,
				draggable: false,
				autoPlay: 4000,
				pageDots:  false
			}).on('staticClick.flickity', function (e, pointer, el, i) {
				if (typeof i == 'number') {
					topbarSlider.flickity('select', i);
				}
			});
			topbarSlider.on( 'select.flickity', function() {
				 topbarSlider.flickity('playPlayer')
				  })
		});

	});
	
}

const initCompImageBreak = () => {
	$('.comp-image-break').each(function () {
		let imageBreak = $(this);
		let imageBreakSlides = imageBreak.find('.image-break-slide');

		if (imageBreakSlides.length > 1) {
			imageBreak.append(`<div class="image-break-paginate width">
				${Array(imageBreakSlides.length).join(0).split(0).map((item, i) => `<button 
						data-paginate="${i}" 
						aria-label="Paginate to ${i} slide" 
						${(i == 0) ? ' class="active"' : ''}></button>
				`).join('')}
			</div>`);
		}

		let imageBreakPagination = imageBreak.find('[data-paginate]');
		let navigateSlides = (direction) => {
			let slideActive = imageBreak.find('[data-paginate].active').index();

			if (direction == 'previous') {
				// if active slide is the first slide
				if (slideActive == 0) {
					// jump to the last slide
					$(imageBreakPagination[imageBreakPagination.length - 1]).trigger('click');
				} else {
					// else, move to previous slide
					$(imageBreakPagination[slideActive - 1]).trigger('click');
				}
			} else if (direction == 'next') {
				// if active slide is the last slide
				if (slideActive + 1 == imageBreakPagination.length) {
					// jump to the first slide
					$(imageBreakPagination[0]).trigger('click');
				} else {
					// else jump to next slide
					$(imageBreakPagination[slideActive + 1]).trigger('click');
				}
			}
		}

		imageBreakPagination.click(function () {
			let _this = $(this);

			_this.addClass('active')
				.siblings().removeClass('active');

			$(imageBreakSlides[_this.data('paginate')]).addClass('active')
				.siblings('.image-break-slide').removeClass('active');
		});

		if (screenIsMobile) {
			xDown = null;

			imageBreak[0].addEventListener('touchstart', handleTouchStart, false)
			imageBreak[0].addEventListener('touchmove', handleTouchMove, false);

			function handleTouchStart(e) {
				firstTouch = (e.touches || e.originalEvent.touches)[0];
				xDown = firstTouch.clientX;
			};

			function handleTouchMove(e) {
				if (!xDown) {
					return;
				}

				var xUp = e.touches[0].clientX;
				var xDiff = xDown - xUp;

				if (xDiff > 5) {
					navigateSlides('next');
				} else if (xDiff < -5) {
					navigateSlides('previous');
				}

				xDown = null;
			};
		}
	});
}

const initCompLightboxVideo = () => {
	// console.log(document.querySelectorAll("[data-lightbox-video]"));
	$('[data-lightbox-video]').each(function () {
		$(this).appendTo(body);
	});

	const allButtons = document.querySelectorAll("[data-lightbox-video-trigger]");
	allButtons.forEach( (child,index) => {
		child.dataset.id = index+1;
		
	});

	$('[data-lightbox-video-trigger]').click(function () {

		const idVideo = Number(this.dataset.id);

		const AllIframes = document.querySelectorAll("[data-lightbox-video]");
		AllIframes.forEach( (child,index) => {

			if(index+1 != idVideo){
				child.style.display = "none";
			}else{
				child.style.display = "flex";
			}

		})

		
		let lightbox = $(`[data-lightbox-video="${$(this).attr('data-lightbox-video-trigger')}"]`);
		let player = new Vimeo.Player(lightbox.find('iframe')[idVideo-1]);

		html.addClass('lightbox_video_active');
		lightbox.addClass('active');

		player.ready().then(function () {
			player.play();
		});

		lightbox.find('.lightbox-close, .lightbox-overlay').click(function () {
			html.removeClass('lightbox_video_active');
			lightbox.removeClass('active');

			player.pause();
		});
	});
}

const initCompShopTheLook = () => {
	$('[data-shop-the-look-trigger]').click(function () {
		let look = $(`[data-shop-the-look="${$(this).attr('data-shop-the-look-trigger')}"]`);
		html.addClass('shop_the_look_active');
		look.addClass('active');

		look.find('.look-close, .look-overlay').click(function () {
			html.removeClass('shop_the_look_active');
			look.removeClass('active');
		});
	});

	$('.shop-the-look').each(function () {
		let look = $(this).appendTo(body);

		if (screenIsTablet) {
			look.find('.comp-product-card').each(function () {
				let product = $(this);

				product.find('.product-quickadd').remove().clone().appendTo(product);
			});

			look.find('.comp-grid-3').removeClass('comp-grid-3 g-flex')
				.flickity({
					cellAlign: 'center',
					wrapAround: true,
					prevNextButtons: false,
					pageDots: true
				});
		}
	});
}

function setWithExpiry(key, value, ttl) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
	localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr || !itemStr.includes('expiry')) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key)
		return null
	}
	return item.value
}

const initCompProductCard = () => {
	swatchRevertOriginal = null;

	// swatches
	_document.on('mouseenter', '[data-swatch-image]', function () {
		let _this = $(this);
		let product = _this.closest('.comp-product-card');
		let productBadge = product.find('.product-badge');
		let thumbnailImg = product.find('.product-thumbnail img').length
			? product.find('.product-thumbnail img')
			: $('<img>').prependTo(product.find('.product-thumbnail')).wrap('<span class="object-fit">');
	
			if (!product.attr('data-badge-original') &&
			product.find('.product-badge.show').length) {
			product.attr('data-badge-original', product.find('.product-badge.show').text());
		}

		if (!product.attr('data-thumbnail-original')) {
			product.attr('data-thumbnail-original',_this.attr('data-swatch-image'));
		}

		clearTimeout(swatchRevertOriginal);

		if (_this.attr('data-swatch-badge')) {
			productBadge.addClass('show')
				.text(_this.attr('data-swatch-badge'));
		} else {
			productBadge.removeClass('show')
		}

		thumbnailImg.css('opacity', 0)
			.attr('data-widths', '[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]')
			.attr('data-srcset',_this.attr('data-swatch-image-srcset'))
			.attr('srcset',_this.attr('data-swatch-image-srcset'))
			.attr('data-aspectratio',_this.attr('data-swatch-image-aspect'))
			.attr('src', _this.attr('data-swatch-image'))
			.addClass('lazyload')
			.load(function () {
				thumbnailImg.css('opacity', 1);
			});
	}).on('mouseleave', '[data-swatch-image]', function () {
		let _this = $(this);
		let product = _this.closest('.comp-product-card');
		let productBadge = product.find('.product-badge');
		let thumbnailImg = product.find('.product-thumbnail img');

		swatchRevertOriginal = setTimeout(function () {
			product.attr('data-badge-original')
				? productBadge.addClass('show')
					.text(product.attr('data-badge-original'))
				: productBadge.removeClass('show');

			thumbnailImg.attr('src', product.attr('data-thumbnail-original'))
				.addClass('css_fadeIn');

			setTimeout(function () {
				thumbnailImg.removeClass('css_fadeIn');
			}, 300);
		}, 300);

		if (_this.hasClass('active')) {
			clearTimeout(swatchRevertOriginal);

			product.attr('data-badge-original', product.find('.product-badge.show').text());

			product.attr('data-thumbnail-original', thumbnailImg.attr('src'));
		}
	}).on('click', '[data-swatch-color]', function () {
		let _this = $(this);
		let product = _this.closest('.comp-product-card');
		let productBadge = product.find('.product-badge');
		let thumbnailImg = product.find('.product-thumbnail img');

		_this.addClass('active')
			.siblings().removeClass('active');

		if (_this.attr('data-swatch-badge')) {
			productBadge.addClass('show')
				.text(_this.attr('data-swatch-badge'));
		}

		if (_this.attr('data-swatch-image')) {
			thumbnailImg.attr('src', _this.attr('data-swatch-image'));
		}

		$(product.find('.product-quickadd ul')[_this.index()]).addClass('active')
			.siblings().removeClass('active');

		product.attr('data-wishlist-variant-id',
			_this.attr('data-swatch-id'));

		product.find('.product-url').attr('href',
			_this.attr('data-url'));
	});

		// swatches-emb
		_document.on('mouseenter', '[data-swatch-image-emb]', function () {
			let _this = $(this);
			let product = _this.closest('.comp-product-card');
			let productBadge = product.find('.product-badge');
			let thumbnailImg = product.find('.product-thumbnail img').length
				? product.find('.product-thumbnail img')
				: $('<img>').prependTo(product.find('.product-thumbnail')).wrap('<span class="object-fit">');
	
			if (!product.attr('data-badge-original') &&
				product.find('.product-badge.show').length) {
				product.attr('data-badge-original', product.find('.product-badge.show').text());
			}
	
			if (!product.attr('data-thumbnail-original')) {
				product.attr('data-thumbnail-original', thumbnailImg.attr('src'));
			}
	
			clearTimeout(swatchRevertOriginal);
	
			if (_this.attr('data-swatch-badge')) {
				productBadge.addClass('show')
					.text(_this.attr('data-swatch-badge'));
			} else {
				productBadge.removeClass('show')
			}
	
			thumbnailImg.css('opacity', 0)
				.attr('srcset', '')
				.attr('src', _this.attr('data-swatch-image-emb'))
				.load(function () {
					thumbnailImg.css('opacity', 1);
				});
		}).on('mouseleave', '[data-swatch-image-emb]', function () {
			let _this = $(this);
			let product = _this.closest('.comp-product-card');
			let productBadge = product.find('.product-badge');
			let thumbnailImg = product.find('.product-thumbnail img');
	
			swatchRevertOriginal = setTimeout(function () {
				product.attr('data-badge-original')
					? productBadge.addClass('show')
						.text(product.attr('data-badge-original'))
					: productBadge.removeClass('show');
	
				thumbnailImg.attr('src', product.attr('data-thumbnail-original'))
					.addClass('css_fadeIn');
	
				setTimeout(function () {
					thumbnailImg.removeClass('css_fadeIn');
				}, 300);
			}, 300);
	
			if (_this.hasClass('active')) {
				clearTimeout(swatchRevertOriginal);
	
				product.attr('data-badge-original', product.find('.product-badge.show').text());
	
				product.attr('data-thumbnail-original', thumbnailImg.attr('src'));
			}
		}).on('click', '[data-swatch-color-emb]', function () {
			let _this = $(this);
			let product = _this.closest('.comp-product-card');
			let productBadge = product.find('.product-badge');
			let thumbnailImg = product.find('.product-thumbnail img');
			let addToCart = $('#AddToCart-emb');
	
			addToCart.attr('data-quickadd-id',_this.attr('data-swatch-id'));
			_this.addClass('active')
				.siblings().removeClass('active');
	
			if (_this.attr('data-swatch-badge')) {
				productBadge.addClass('show')
					.text(_this.attr('data-swatch-badge'));
			}
	
			if (_this.attr('data-swatch-image')) {
				thumbnailImg.attr('src', _this.attr('data-swatch-image'));
			}
	
			$(product.find('.product-quickadd ul')[_this.index()]).addClass('active')
				.siblings().removeClass('active');
	
			product.attr('data-wishlist-variant-id',
				_this.attr('data-swatch-id'));
	
		});

	// remove empty quickadd ULs
	$('.product-quickadd ul').each(function () {
		(!$(this).find('li').length)
			? $(this).remove() : '';
	});

	// assign active state to the first available quick add ul
	// need this for products without swatches
	$('.product-quickadd ul:first-of-type').addClass('active');

	// trigger first variant image on load
	$('[data-swatch-image].active').trigger('mouseenter');
}

const initCompToggle = () => {
	_document.on('click', '.toggle-label', function () {
		$(this).siblings('.toggle-content').slideToggle()
			.closest('.toggle').toggleClass('active')
			.siblings().removeClass('active')
			.find('.toggle-content').slideUp();
	});
}

const initProductImagesPopup = () => {
	const productImagesPopup = $('#product-images-popup');
	const productImagesPopupClose = productImagesPopup.find('#product-images-popup-close');
	const galleryImageFeatured = productImagesPopup.find('#gallery-image-featured');
	const popupOverlay = productImagesPopup.find('#product-images-popup-overlay');

	const productImagesPopupCloseTrigger = () => {
		html.removeClass('product_images_popup_active');
	}

	// close newsletter on click
	popupOverlay.click(productImagesPopupCloseTrigger);
	galleryImageFeatured.click(productImagesPopupCloseTrigger);
	productImagesPopupClose.click(productImagesPopupCloseTrigger);
}

const initImageGallery = () => {
	// images
	const galleryImagesList = $('#gallery-images-list [data-image]');
	const galleryFeaturedImages = $('#gallery-image-featured .image');
	const heroImages = $('#hero-images-featured-interior .image');

	const normalSwatch = document.querySelector(".swatch-list.swatch-list-normal button.active");
	let label = "";

	if(normalSwatch){
		label = normalSwatch.ariaLabel;
	}

	const specialSwatch = document.querySelector(".swatch-list.swatch-list-special button.active");

	if(specialSwatch){
		label = specialSwatch.ariaLabel;
	}

	if(label != ""){

		Array.from(galleryImagesList).forEach(child => {
			if(!child.dataset.imageAlt.includes(label)){
				child.remove();
			}
		});

		let active = false;
		
		Array.from(galleryFeaturedImages).forEach(child  => {

			if(child.children[0].alt != null){
				if(!child.children[0].alt.includes(label)){
					child.remove();
				}else{
					if(!active){
						child.classList.add("active");
						active=true;
					}
					
				}
			}
		});

	}


	const imageHideBasedOnSize = () => {
		let variantActive = $('.product-variants [data-variant-id].active');
		
		imageShowIndex = [];
		imageHasSizeIndex = [];

		galleryImagesList.each(function (i) {
			let alt = $(this).attr('data-image-alt');
			let altSize = alt.substring(
				alt.lastIndexOf(':') + 1,
				alt.lastIndexOf('@')).split(',');

			if (altSize[0] && !altSize[0].includes('iframe')) {
				imageHasSizeIndex.push(i);

				if (altSize.includes(variantActive.text().trim())) {
					imageShowIndex.push(i);
				}
			}
		});

		galleryImagesList.each(function (i) {
			let _this = $(this);

			_this.removeClass('hidden');
			$(galleryFeaturedImages[i]).removeClass('hidden');

			if (imageShowIndex.length) {
				if (!imageShowIndex.includes(i)) {
					_this.addClass('hidden');
					$(galleryFeaturedImages[i]).addClass('hidden');
				}
			} else if (imageHasSizeIndex.includes(i)) {
				_this.addClass('hidden');
				$(galleryFeaturedImages[i]).addClass('hidden');
			}
		});
	}

	galleryImagesList.click(function () {
		let _this = $(this);

		_this.addClass('active')
			.siblings().removeClass('active');

		$(galleryFeaturedImages[_this.attr('data-image')])
			.addClass('active')
			.siblings().removeClass('active');
	});

	initProductImagesPopup();

	heroImages.click(function() {
		let _this = $(this);
		const imageIndex = _this.attr('data-image')
		
		html.addClass('product_images_popup_active');
		
		$(galleryImagesList[imageIndex])
			.addClass('active')
			.siblings().removeClass('active');
		
		$(galleryFeaturedImages[imageIndex])
			.addClass('active')
			.siblings().removeClass('active');
	});
	if (screenIsTablet) {
		$('#gallery-image-featured-interior').removeClass('thumbnail');
		$('#gallery-images-list').remove();
	}
}

// 4.0 INIT APP

keyOnPress = false;

_document.on('keydown', function () {
	keyOnPress = true;
}).on('keyup', function () {
	keyOnPress = false;
});

scrollTop = 0;
_window.on('scroll', function () {
	scrollTop = _window.scrollTop();
});

siteReadyTrigger(function () {
	scrollTop = _window.scrollTop();
});

initHeader();
initNewsletterPopup();
initSearchPane();
initSearchIndex();
initCart();

initFields();
initCompNavigationSticky();
initCompNavigationStickySust();
initCompNewsletter();
initCompSlider();
initCompSliderTestimonial();
initCompImageBreak();
initCompLightboxVideo();
initCompShopTheLook();
initCompProductCard();
initCompToggle();
initCompAppointmentEmbed();

window.onload = function () {
	initCompSliderTopbar();
}

switch (html.attr('id')) {
	case 'frontpage':
		initFrontpage();
		break;

	case 'collection-listing':
		initCollectionListing();
		break;

	case 'product-index':
		initProductIndex();
		break;

	case 'product-single':
		initProductSingle();
		initSizeGuide();
		break;

	case 'blog-index':
		initBlogIndex();
		break;

	case 'blog-single':
		initBlogSingle();
		initLocationsSingle();
		break;

	case 'page-careers':
		initCareers();
		break;

	case 'page-customer-service':
		initCx();
		break;

	case 'page-fabric-care':
		initFabricCare();
		break;

	case 'page-fabric-care-1':
		initFabricCare();
		break;

	case 'page-valentines-day':
		initValentinesDay();
		break;

	case 'page-self-love-letter-giveaway':
		initValentinesDay();
		break;

	case 'accounts':
		initAccounts();
		break;
}

initPageTransition();
initPageAnimation();

// RESIZING REFRESH PAGE
/*  _window.on('resize', function() {
	if ((!screenisCompact && _window.width() < 1200) ||
		(screenisCompact && _window.width() >= 1200) ||
		(!screenIsTablet && _window.width() < 900) ||
		(screenIsTablet && _window.width() >= 900) ||
		(!screenIsMobile && _window.width() < 600) ||
		(screenIsMobile && _window.width() >= 600)) {
		body.hide();
		this.location.href = this.location.href;
	}
});
 */

if (window.location.hash == '#contact_form') {
	scrollTo(0);
	history.replaceState(null, null, ' ');
} else if (window.location.hash &&
	$(window.location.hash).length) {
	scrollTo(window.location.hash);
	history.replaceState(null, null, ' ');
}

// swiping fix for IOS
(function () {
	var touchingCarousel = false,
		touchStartCoords;

	document.body.addEventListener('touchstart', function (e) {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}

		touchStartCoords = {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY
		}
	});

	document.body.addEventListener('touchmove', function (e) {
		if (!(touchingCarousel && e.cancelable)) {
			return;
		}

		var moveVector = {
			x: e.touches[0].pageX - touchStartCoords.x,
			y: e.touches[0].pageY - touchStartCoords.y
		};

		if (Math.abs(moveVector.x) > 7)
			e.preventDefault()

	}, { passive: false });
})();

$('[data-scroll-to]').click(function () {
	scrollTo($(this).attr('data-scroll-to'));
});

$('.video').fitVids();


window.__rmcp2 = JSON.parse(localStorage.getItem('rmcp2Cookie'));
window.__rmuspc = "YN";

jQuery.loadScript = function (url, callback) {
    jQuery.ajax({
        url: url,
        dataType: 'script',
        success: callback,
        async: true
    });
}

const initCompMiniCart = () => {
    setTimeout(function () {
        if (window.frames.document.getElementById('qty-plus')) {
			let qtyMinus = document.querySelectorAll('.item-quantity-decrease')
			let qtyPlus = document.querySelectorAll('.item-quantity-increase')
			let itemRemove = document.querySelectorAll('.item-remove')

			qtyMinus.forEach(element => {
				element.addEventListener("click", function(_rsq){
					// update the getElementById param to the ID name of the update to cart button
					window.setTimeout(_check_cart, 200);
			   });
			});

			qtyPlus.forEach(element => {
				element.addEventListener("click", function(_rsq){
					// update the getElementById param to the ID name of the update to cart button
					window.setTimeout(_check_cart, 2000);
			   });
			});

			if (window.frames.document.getElementById('remove-item')) {
				itemRemove.forEach(element => {
					element.addEventListener("click", function(_rsq){
						// update the getElementById param to the ID name of the update to cart button
						window.setTimeout(_check_cart, 2000);
				   });
				});
			}
		}
}, 2500);
}

/*** AJAX Add to Cart ***/
window.addEventListener('DOMContentLoaded', function(_rsq){
	if (window.frames.document.getElementById('add-to-cart-btn')) {
	    window.frames.document.getElementById('add-to-cart-btn').addEventListener("click", function(_rsq){
			//	_check_cart2();
			// update the getElementById param to the ID name of the add to cart button
			window.setTimeout(_check_cart, 2000);
		});	
	}

});

/*** AJAX QUICK Add to Cart ***/
window.addEventListener('DOMContentLoaded', function(_rsq){
	let quickAddBtns = document.querySelectorAll('.quick-add-btn')
	if (quickAddBtns) {
		quickAddBtns.forEach(element => {

			element.addEventListener("click", function(_rsq){
				// update the getElementById param to the ID name of the add to cart button
				
//				_check_cart2();

				window.setTimeout(_check_cart, 2000);					

			});

		});

				

	};
		
})
    /* window.frames.document.getElementById('add-to-cart-btn').addEventListener("click", function(_rsq){
        update the getElementById param to the ID name of the add to cart button
        window.setTimeout(_check_cart, 2000);
		console.log("add to cart OK Hotjar")
    }); */
// });

/*** AJAX Cart View ***/
window.addEventListener('DOMContentLoaded', function(_rsq){
	if (window.frames.document.getElementById('minicart-trigger')) {
		window.frames.document.getElementById('minicart-trigger').addEventListener("click", function(_rsq){
			// update the getElementById param to the ID name of the show cart button or cart icon
			_rs_ajax.updateCart();
			});
	}
});

window.addEventListener('DOMContentLoaded', function(_rsq){

	if (window.frames.document.getElementById('product-sticky-header')) {
		window.frames.document.getElementById('product-sticky-header').querySelector(".btn-block").addEventListener("click", function(_rsq){
			// update the getElementById param to the ID name of the show cart button or cart icon
			//_check_cart2();
				window.setTimeout(_check_cart, 2000);
			});
	}
});

window.addEventListener('DOMContentLoaded', function(_rsq){
	
	if (window.frames.document.getElementById('add-to-cart-kit')) {
		window.frames.document.getElementById('add-to-cart-kit').addEventListener("click", function(_rsq){
			// update the getElementById param to the ID name of the show cart button or cart icon
			//	_check_cart2();
				window.setTimeout(_check_cart, 2000);
			});
	}
});

window.addEventListener('DOMContentLoaded', function(_rsq){
	
	if (window.frames.document.getElementById('AddToCart-emb')) {
		window.frames.document.getElementById('AddToCart-emb').addEventListener("click", function(_rsq){
			// update the getElementById param to the ID name of the show cart button or cart icon
			//	_check_cart2();
				window.setTimeout(_check_cart, 2000);
			});
	}
});

   /*** AJAX Update to Cart ***/
   window.addEventListener('DOMContentLoaded', function(_rsq){
	   if (window.frames.document.getElementById('qty-plus')) {
			window.frames.document.getElementById('qty-plus').addEventListener("click", function(_rsq){
				// update the getElementById param to the ID name of the update to cart button
				window.setTimeout(_check_cart, 2000);
		});
	   }
	  if ( window.frames.document.getElementById('qty-minus')) {
		window.frames.document.getElementById('qty-minus').addEventListener("click", function(_rsq){
			// update the getElementById param to the ID name of the update to cart button
			window.setTimeout(_check_cart, 2000);
			});
	  }
	  if (window.frames.document.getElementById('remove-item')) {
		window.frames.document.getElementById('remove-item').addEventListener("click", function(_rsq){
			// update the getElementById param to the ID name of the update to cart button
			window.setTimeout(_check_cart, 2000);
		});
	  }
   });

/*** FUNCTION FOR AJAX TRACKING ***/
var _rs_ajax = {};
_rs_ajax.updateCart = function() { //This is required for ajax cart views
    var request = new XMLHttpRequest();
    request.open('GET', '/cart.js', true);
    request.onload = function() {
        if (request.status >= 200 && request.status < 400) { // Success!
            var cart = JSON.parse(request.responseText);
            for(var i=0; i<cart.items.length; i++) {
                var cartItem = cart.items[i];
                var price = cartItem.price / 100;
                _rsq.push(['_addItem', { 'id':cartItem.id.toString(), 'name':cartItem.title.toString(),'price':price.toFixed(2).toString() }]);
            }
            _rsq.push(['_setAction', 'shopping_cart']); 
           _rsq.push(['_track']);
       }
    };
    request.onerror = function() {
       console.log("Shopify Cart JS Failed");
    };
    request.send();
};
function _check_cart2(){
	setTimeout(() => {

		jQuery.getJSON('/cart.js',function(cart){
			console.log(cart);
			const products = cart.items.reverse();

			const minicart = document.getElementById("minicart");
			minicart.classList.add("has_items");

			const minicart_trigger = document.getElementById("minicart-trigger");
			minicart_trigger.classList.add("has_items");

			const cartItems = document.getElementById("cart-items");
			cartItems.querySelectorAll(".item").forEach(child => child.remove());
			document.querySelectorAll(".remove-section").forEach(child => child.remove());

			products.forEach(product => {


				const {properties} = product;
				let infoFooter = "";

				if(!properties?.iskit){

					 infoFooter = `										

					 <div class="item-info-footer">
						<div class="item-quantity cr-moon user-select-disable" data-quantity-max="89" data-quantity-min="0">

							<button id="qty-minus" type="button" class="item-quantity-decrease">		
								<svg class="svg-plus" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9883 5L0.988281 5" stroke="currentColor"></path></svg>
							</button>
							<span class="item-quantity-current">${product.quantity}</span>
							<button id="qty-plus" type="button" class="item-quantity-increase">														
								<svg class="svg-plus" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.98828 2.17038e-06L5.98828 10" stroke="currentColor"></path><path d="M10.9883 5L0.988281 5" stroke="currentColor"></path></svg>
							</button>

						</div>
					</div>
				 `;
				}

				if(properties?.iskit){
					console.log("iskit");
					if(properties.kitindex == 0){

						const headerKit = document.createElement("DIV");
						headerKit.id = properties.kitKey;
						headerKit.classList.add("remove-section");
						headerKit.dataset.kitNameOrder= `${properties.kitname}-${properties.kitkey}`;
						headerKit.innerHTML = `
							<p class="t-h-5 cart-kit-title cart-kit-name--${properties.kitname}" data-kit-name-order="${properties.kitname}-${properties.kitkey}" data-kit-name="${properties.kitname}">${properties.kitname.replaceAll("-"," ")}</p> 
							<button id="remove-item" data-remove-kit="${properties.kitname}" data-kit-name="${properties.kitname}" data-kit-name-order="${properties.kitname}-${properties.kitkey}" type="button" class="item-remove item-remove-kit btn-underline-small">
							Remove</button>
						`;

						cartItems.appendChild(headerKit);

					}

				}

				let infoContent = "";
				if(properties?.["embroidery-id"]){

					infoContent = `
					<div class="item-info-content">
						<h3 class="t-b-2">Embroidery</h3>	
						<div class="item-info-emb">							
							<p class="t-caption">embroidery text: ${properties?.["embroidery text"]}</p>
							<p class="t-caption">embroidery-color: ${properties?.["embroidery-color"]}</p>
						</div>

						<span class="t-caption item-quantity-current">QTY: ${product.quantity}</span>
						
						<p class="t-caption" style="margin-top:5px;">FINAL SALE ITEM</p>				
							<button type="button" style="display:none" class="item-edit btn-underline-small ">
						Edit</button>
					<div class="item-info-footer">
						<div class="item-quantity cr-moon user-select-disable" data-quantity-max="-106" data-quantity-min="0" style="display: none;">
							<button id="qty-minus" type="button" class="item-quantity-decrease">		
								<svg class="svg-plus" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9883 5L0.988281 5" stroke="currentColor"></path></svg>
							</button>
							<span class="item-quantity-current">${product.quantity}</span>
							<button id="qty-plus" type="button" class="item-quantity-increase">
								<svg class="svg-plus" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.98828 2.17038e-06L5.98828 10" stroke="currentColor"></path><path d="M10.9883 5L0.988281 5" stroke="currentColor"></path></svg>
							</button>
					</div>
	
					<button id="remove-item" type="button" class="item-remove btn-underline-small item-remove-mini">
					Remove</button>						
						<div style="visibility: hidden;" class="item-info-price t-b-2">
							$ ${product.price/100}
						</div>
					</div>
				</div>

					`

				}else{
					infoContent = `
						<div class="item-info-content">
							<h3 class="t-b-2">${product.product_title}</h3>
							<div class="item-action-reveal">
								<p style="color: var(--cr-subdued); text-transform: uppercase; letter-spacing: 0.03em; font: var(--t-caption);">${product.title}</p>
							</div>

							${infoFooter}

						</div>
					`
				}


				const productHTML = `
					
					<div id="kitItem-${properties?.iskit ? properties.kitkey : "" }" class="item g-flex" data-product-id="${product.product_id}" data-product-title="${product.product_title}" data-product-type="${product.product_type}" data-item-id="${product.id}" data-item-key="${product.key}" data-item-price="${product.price/100}" 
					data-kit-name="${properties?.iskit ?properties.kitname : ""}"  data-kit-name-order="${properties?.iskit ? properties.kitname+"-"+properties.kitkey : ""}"					
					data-product-emb="${properties?.["embroidery-id"] ? properties?.["embroidery-id"] : ""}"
					>


						<div class="item-info g-flex g-top">

							<div class="item-thumbnail thumbnail">
								<a href="${product.url}" class="object-fit" title="${product.product_title}" data-location="internal">
									<img src="${product.image}" class="lazyautosizes ls-is-cached lazyloaded" >
								</a>
							</div>

							${infoContent}

						</div>

						<div class="items-price">
								<div class="item-pricing t-b-2">
									$ ${product.price/100}
								</div>
						</div>

					</div>
				`;

				cartItems.innerHTML += productHTML;


			})

		})
			

	},2000)
}

function getProductInfo(handle) {
	return new Promise(function(resolve, reject) {
		jQuery.getJSON('/products/'+ handle +'.js', function(product) {
			resolve(product);
		});
	});
  }

function _check_cart2(){

	setTimeout(() => {

		jQuery.getJSON('/cart.js',function(cart){
			console.log(cart);
			const products = cart.items;

			const minicart = document.getElementById("minicart");
			minicart.classList.add("has_items");

			const minicart_trigger = document.getElementById("minicart-trigger");
			minicart_trigger.classList.add("has_items");

			const cartItems = document.getElementById("cart-items");
			cartItems.querySelectorAll(".item").forEach(child => child.remove());
			document.querySelectorAll(".remove-section").forEach(child => child.remove());


			products.forEach(product => {

				// Request new product info via JS API
				let promise = getProductInfo(product.handle)
					promise.then(function(result) {
					makeCart(result)
				}, function(error) {
					console.warn('Theme | recently viewed products failed to load');
				});

				function makeCart(productResult) {
					const {properties} = product;
					let finalSale = false;
					let priceVar = false;
					if (productResult.tags.includes('final-sale')) {
						finalSale = true;
					}
					if (productResult.compare_at_price > productResult.price) {
						priceVar = true;
					}
					let infoFooter = "";
					if(!properties?.iskit){
	
						 infoFooter = `										
	
						 <div class="item-info-footer">
							<div class="item-quantity cr-moon user-select-disable" data-quantity-max="89" data-quantity-min="0">
	
								<button id="qty-minus" type="button" class="item-quantity-decrease">		
									<svg class="svg-plus" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9883 5L0.988281 5" stroke="currentColor"></path></svg>
								</button>
								<span class="item-quantity-current">${product.quantity}</span>
								<button id="qty-plus" type="button" class="item-quantity-increase">														
									<svg class="svg-plus" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.98828 2.17038e-06L5.98828 10" stroke="currentColor"></path><path d="M10.9883 5L0.988281 5" stroke="currentColor"></path></svg>
								</button>
	
							</div>
						</div>
					 `;
					}
	
					if(properties?.iskit){
						if(properties.kitindex == 0){
	
							const headerKit = document.createElement("DIV");
							headerKit.id = properties.kitKey;
							headerKit.classList.add("remove-section");
							headerKit.dataset.kitNameOrder= `${properties.kitname}-${properties.kitkey}`;
							headerKit.innerHTML = `
								<p class="t-h-5 cart-kit-title cart-kit-name--${properties.kitname}" data-kit-name-order="${properties.kitname}-${properties.kitkey}" data-kit-name="${properties.kitname}">${properties.kitname.replaceAll("-"," ")}</p> 
								<button id="remove-item" data-remove-kit="${properties.kitname}" data-kit-name="${properties.kitname}" data-kit-name-order="${properties.kitname}-${properties.kitkey}" type="button" class="item-remove item-remove-kit btn-underline-small">
								Remove</button>
							`;
	
							cartItems.appendChild(headerKit);
	
						}
	
					}
	
					let infoContent = "";
					if(properties?.["embroidery-id"]){
	
						infoContent = `
						<div class="item-info-content">
							<h3 class="t-b-2">Embroidery</h3>	
							<div class="item-info-emb">							
								<p class="t-caption">embroidery text: ${properties?.["embroidery text"]}</p>
								<p class="t-caption">embroidery-color: ${properties?.["embroidery-color"]}</p>
							</div>
	
							<span class="t-caption item-quantity-current">QTY: ${product.quantity}</span>
							
							<p class="t-caption" style="margin-top:5px;">FINAL SALE ITEM</p>				
								<button type="button" style="display:none" class="item-edit btn-underline-small ">
							Edit</button>
						<div class="item-info-footer">
							<div class="item-quantity cr-moon user-select-disable" data-quantity-max="-106" data-quantity-min="0" style="display: none;">
								<button id="qty-minus" type="button" class="item-quantity-decrease">		
									<svg class="svg-plus" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9883 5L0.988281 5" stroke="currentColor"></path></svg>
								</button>
								<span class="item-quantity-current">${product.quantity}</span>
								<button id="qty-plus" type="button" class="item-quantity-increase">
									<svg class="svg-plus" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.98828 2.17038e-06L5.98828 10" stroke="currentColor"></path><path d="M10.9883 5L0.988281 5" stroke="currentColor"></path></svg>
								</button>
						</div>
		
						<button id="remove-item" type="button" class="item-remove btn-underline-small item-remove-mini">
						Remove</button>						
							<div style="visibility: hidden;" class="item-info-price t-b-2">
								$ ${product.price/100}
							</div>
						</div>
					</div>
	
						`
	
					}else{
						infoContent = `
							<div class="item-info-content">
								<h3 class="t-b-2">${product.product_title}</h3>
								<div class="item-action-reveal">
									<p style="color: var(--cr-subdued); text-transform: uppercase; letter-spacing: 0.03em; font: var(--t-caption);">${product.title}</p>
								</div>
	
								${infoFooter}
	
							</div>
						`
					}
	
	
					const productHTML = `
						
						<div id="kitItem-${properties?.iskit ? properties.kitkey : "" }" class="item g-flex" data-product-id="${product.product_id}" data-product-title="${product.product_title}" data-product-type="${product.product_type}" data-item-id="${product.id}" data-item-key="${product.key}" data-item-price="${product.price/100}" 
						data-kit-name="${properties?.iskit ?properties.kitname : ""}"  data-kit-name-order="${properties?.iskit ? properties.kitname+"-"+properties.kitkey : ""}"					
						data-product-emb="${properties?.["embroidery-id"] ? properties?.["embroidery-id"] : ""}"
						>
	
	
							<div class="item-info g-flex g-top">
	
								<div class="item-thumbnail thumbnail">
									<a href="${product.url}" class="object-fit" title="${product.product_title}" data-location="internal">
										<img src="${product.image}" class="lazyautosizes ls-is-cached lazyloaded" >
									</a>
								</div>
	
								${infoContent}
	
							</div>
	
							<div class="items-price">
									<div class="item-pricing t-b-2">
									<s class="cr-subdued ${priceVar? "" : "hide" }">$ ${productResult.compare_at_price/100}</s>
									<s class="cr-subdued ${properties?.iskit? "" : "hide" }">$ ${((product.price/100)*0.85)}</s>
									<span class="price">$ ${product.price/100}</span>
									</div>
							</div>
							<div class="final-item">
								<p class="t-link ${finalSale? "" : "hide" }">FINAL SALE ITEM</p>
							</div>
						</div>
					`;
	
					cartItems.innerHTML += productHTML;
				}


			})

		})
			

	},2000)
}

function _check_cart() {
	
    var request = new XMLHttpRequest();
    request.open('GET', '/cart.js', true);
    request.onload = function() {
        if (request.status >= 200 && request.status < 400) { // Success!
            var cart = JSON.parse(request.responseText);
            for(var i=0; i<cart.items.length; i++){
                var cartItem = cart.items[i];
                var price = cartItem.price / 100;
                _rsq.push(['_addItem', { 'id':cartItem.id.toString(), 'name':cartItem.title.toString(),'price':price.toFixed(2).toString() }]);
            }
            window._rsq.push(['_setAction', 'shopping_cart']); 
            window._rsq.push(['_track']);
        }
     };
     request.onerror = function() {
        console.log("error");
     };
     request.send(); 
} 
/*** END FUNCTION FOR AJAX TRACKING ***/




let imageTabs = $('.variant-banner');
if (imageTabs) {
	imageTabs.each(function () {
		// assign active states
		$(this).click(function () {
		$(this).addClass('active').siblings().removeClass('active');
		imageHideBasedOnSizeTabs();
		})
	})

	let imageTabsMobile = $('.variant-banner-mobile');
	const variantsBtns = $('.product-variants button.t-link');
	
if (imageTabsMobile) {
	imageTabsMobile.each(function () {
		// assign active states
		$(this).click(function () {
		$(this).addClass('active').siblings().removeClass('active');
 		if ($(this).html().toLowerCase().includes('x-large')) {
			variantsBtns.each(function() {
				if ($(this).html().includes('1X') || $(this).html().includes('2X')  || $(this).html().includes('3X')) {
					$(this).click();
					return false;
				}
			})
		} else {
			variantsBtns.each(function() {
				if ($(this).html().includes('XS') || $(this).html().includes('S')  || $(this).html().includes('M')) {
					$(this).click();
					return false;
				}
			})
		} 
		})
	})
}
// WAIT LIST COLLECTION

const waitlistCollection = (product) => {
		// product waitlist
		const waitlist = $('#collection-waitlist');
		const waitlistEmail = waitlist.find('[name="collection-waitlist-email"]');
		const waitlistVariantId = waitlist.find('[name="collection-waitlist-variant-id"]');
		const waitlistProductId = waitlist.find('[name="collection-waitlist-product-id"]');

  		waitlist.submit(function (e) {
			e.preventDefault();
	
			loadingBarTrigger('start');
	
			if (!waitlistEmail.val() ||
				!validateEmail(waitlistEmail.val())) {
	
				waitlist.find('.newsletter-email-field')
					.addClass('error');
			} else {
				BIS.create(
					waitlistEmail.val(),
					waitlistVariantId.val(),
					waitlist.find('[name="collection-waitlist-product-id"]').val()
				).then(function (data) {
					var msg = '';
					loadingBarTrigger('done');
	
					if (data.status == 'OK') {
						waitlist.addClass('success');
					} else {
						//console.error(data)
					}
				});
			}
		});  
}

function initWaitlistvalues(product) {
	const waitlist = $('#collection-waitlist');
	let waitlistVariantId = waitlist.find('[name="collection-waitlist-variant-id"]');
	let waitlistProductId = waitlist.find('[name="collection-waitlist-product-id"]');
	let waitlistVariantSize = $("#collection-waitlist-variant-size");
	let waitlistProductName =  $("#collection-waitlist-product-name");
	let sizeValue = product.attr('data-quickadd-product-size');
	let correctSize;
	let waitlistBtn = waitlist.find(':submit')
	
	switch (sizeValue) {
		case 'XS':
			correctSize = "Extra Small"
			break;
		case 'XS/S':
			correctSize = "Extra Small/Small"
			break;
		case 'XS/S/M':
			correctSize = "Extra Small/Small/Medium"
			break;
		case 'S':
			correctSize = "Small"
			break;
		case 'S/M':
			correctSize = "Small/Medium"
			break;
		case 'M':
			correctSize = "Medium"
			break;	
		case 'M/L':
			correctSize = "Medium/Large"
			break;	
		case 'L':
			correctSize = "Large"
			break;	
		case 'L/XL':
			correctSize = "Large/Extra Large"
			break;
		case 'XL':
			correctSize = "Extra Large"
			break;
		case 'XL2':
			correctSize = "Extra Large 2"
			break;
		case 'XL3':
			correctSize = "Extra Large 3"
			break;
		case 'XL2/XL3':
			correctSize = "Extra Large 2/3"
			break;
		case 'XXL':
			correctSize = "Extra(x2) Large "
			break;
		case 'OSmall':
			correctSize = "One Size"
			break;
		case 'OS':
			correctSize = "One Size"
			break;
		default:
			break;
	}

	waitlistProductId.val(product.attr('data-quickadd-product-id'))
	waitlistVariantId.val(product.attr('data-quickadd-id'))
	waitlistVariantSize[0].innerHTML = correctSize;
	waitlistProductName[0].innerHTML = product.attr('data-quickadd-product-name')
	waitlistBtn[0].addEventListener('click',function(){
		waitlistCollection();
	})

}
}

const initProductSingleEmb = () => {
	// images
	const heroImagesListImage = $('#hero-images-list-emb [data-image]');
	const heroImagesFeaturedImages = $('#hero-images-featured-emb .image');
	const embImages = $('.product-hero-images-emb')
	if(screenIsTablet){
		embImages.insertAfter($('#emb-title'))
	}

	const imageHideBasedOnSize = () => {
		let variantActive = $('.product-variants [data-variant-id].active');
		imageShowIndex = [];
		imageHasSizeIndex = [];
		
		heroImagesListImage.each(function (i) {
			let alt = $(this).attr('data-image-alt');
			let altSize = alt.substring(
				alt.lastIndexOf(':') + 1,
				alt.lastIndexOf('@')).split(',');

			if (altSize[0] && !altSize[0].includes('iframe')) {
				imageHasSizeIndex.push(i);

				if (altSize.includes(variantActive.text().trim())) {
					imageShowIndex.push(i);
				}
			}
		});

		heroImagesListImage.each(function (i) {
			let _this = $(this);
			
			_this.removeClass('hidden');
			$(heroImagesFeaturedImages[i]).removeClass('hidden');

			if (imageShowIndex.length) {
				if (!imageShowIndex.includes(i)) {
					_this.addClass('hidden');
					$(heroImagesFeaturedImages[i]).addClass('hidden');
				}
			} else if (imageHasSizeIndex.includes(i)) {
				_this.addClass('hidden');
				$(heroImagesFeaturedImages[i]).addClass('hidden');
			}
		});

		$('#hero-images-list-emb [data-image]:not(.hidden)').first().click();

		if (screenIsTablet) {
			let heroImagesFeaturedInterior = $('#hero-images-featured-interior-emb');

			if (heroImagesFeaturedInterior.hasClass('flickity-enabled')) {
				heroImagesFeaturedInterior.flickity('destroy');
			}

			heroImagesFeaturedInterior.flickity({
				cellAlign: 'center',
				cellSelector: '.image:not(.hidden)',
				wrapAround: false,
				prevNextButtons: true,
				pageDots: false,
				draggable: true,
				freeScroll: true
			});
		}
	}


	const imageZoomTrigger = () => {
		if (screenIsTablet) {
			let toggleSliderDraggability = () => {
				let flickityData = $('#hero-images-featured-interior-emb').data('flickity');

				flickityData.options.draggable = !flickityData.options.draggable;
				flickityData.updateDraggable();
			}

			html.on('touchstart', function (e) {
				imageTouchStart = setTimeout(function () {
					$('#hero-images-featured-emb .image').zoom({
						on: 'click',
						duration: 200,
						touch: true
					});
				}, 10);
			}).on('touchend', function () {
				clearTimeout(imageTouchStart);

				$('#hero-images-featured-emb .image').each(function () {
					let _this = $(this);
					if (_this.find('[role="presentation"]').length) {
						_this.trigger('zoom.destroy');
					}
				});
			});
		} else {
			$('#hero-images-featured-emb .image.active').zoom({
				on: 'click',
				duration: 200,
				magnify: 1.2,
				touch: false,
			});
		}
	}

	heroImagesListImage.click(function () {
		let _this = $(this);

		_this.addClass('active')
			.siblings().removeClass('active');

		$(heroImagesFeaturedImages[_this.attr('data-image')])
			.addClass('active')
			.siblings().removeClass('active');

		imageZoomTrigger();
	});

 	$('#product-hero-content [data-swatch-color][data-url]').click(function () {
		window.location.href = $(this).attr('data-url');
	});
 
 	if (screenIsTablet) {
		$('#hero-images-featured-interior-emb').removeClass('thumbnail');

		$('#hero-images-list-emb').remove();
	} 

	imageHideBasedOnSize();
	imageZoomTrigger();

}

initProductSingleEmb()